import React from 'react'
import { useState, useEffect , useRef } from 'react';
import Select from 'react-select';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import axios from 'axios'
import ToastNotification from '../../../components/ToastNotification';
import { Modal, Button, Table, Form } from "react-bootstrap";
import { CiEdit } from "react-icons/ci";
import { useLoading } from '../../../context/LoadingContext';
import { MdDeleteForever } from "react-icons/md";
import logo from '../../../assets/logo.png';
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import { FaDownload } from "react-icons/fa6";
import { useLocation } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';
import { toWords } from "number-to-words";


const Return = ({ adminData, branchID,companyID , financialYear }) => {
    const searchInputRef = useRef(null);
    const location = useLocation();
          const mode = location.state?.mode;
          const partyId = location.state?.partyId;
          const editData = location.state?.data;

    const [docOptions, setDocOptions] = useState([]);
    const { setLoading } = useLoading();
    const [selectedDoc, setSelectedDoc] = useState(null);
    const [purchase, setPurchase] = useState([]);
    const [purchaseOrder, setPurchaseOrder] = useState([]);
    const [showPartyModal, setShowPartyModal] = useState(false);
    const [search, setSearch] = useState("");

    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };
    const [editingIndex, setEditingIndex] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [partyOptions, setPartyOptions] = useState([]);
    const [inventory, setInventory] = useState([]);
    const [editItemData, setEditItemData] = useState(null); 
    const [editItemIndex, setEditItemIndex] = useState(null);
    const [editPurchaseId, setEditPurchaseId] = useState(null);
    const [viewBillData, setViewBillData] = useState(null);
    const [deleteMode, setDeleteMode] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    // const [refDocOptions, setRefDocOptions] = useState([]);
    const [purchaseData, setPurchaseData] = useState([]);
    const [selectedParty, setSelectedParty] = useState("");
    const [totalGST, setTotalGST] = useState(0);
    const [subTotal, setSubTotal] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [isEditMode, setIsEditMode] = useState(false);
    const [branchDetail, setBranchDetail] = useState([])
    const [fetchQuoataion, setFetchQuoataion] = useState([]);
    const [chargeMaster, setChargeMaster] = useState([]);
    const [chargeOptions, setChargeOptions] = useState([]);
    const [editingCompanyId, setEditingCompanyId] = useState(null)
    const [invoiceNo, setInvoiceNo] = useState('');
    const [items, setItems] = useState([]);
    const [detail, setDetail] = useState([])
    const [searchTerm, setSearchTerm] = useState('');
    const [totalTax, setTotalTax] = useState(0);
    const[fetchReturn,setFetchReturn] = useState([]);
      const [selectedQuotation, setSelectedQuotation] = useState(null);
      const [showDownloadModal, setShowDownloadModal] = useState(false);
        const [company, setCompany] = useState([]);
          const [useDefaultShipping, setUseDefaultShipping] = useState(true);

              const [payableAmount, setPayableAmount] = useState(0);
                   const [cgst, setCgst] = useState(0);
                   const [sgst, setSgst] = useState(0);
                   const [igst, setIgst] = useState(0);
                   const [roundOff, setRoundOff] = useState(0);
                   const [billDiscountPercent, setBillDiscountPercent] = useState(0);
                   const [billDiscountAmount, setBillDiscountAmount] = useState(0);
                   const [afterBillDiscountAmount, setAfterBillDiscountAmount] = useState(0);
                   const [billDiscountType, setBillDiscountType] = useState("percent");
                   const [billDiscountValue, setBillDiscountValue] = useState(0);
                  const [extraChargesTotal,setExtraChargesTotal]=useState(0);
                    const [totalDiscount, setTotalDiscount] = useState("0.00");


      useEffect(() => {
        if (showPartyModal) {
          setTimeout(() => {
            searchInputRef.current?.focus();
          }, 100);
        }
      }, [showPartyModal]);


           const getTodayDateTime = () => {
        const now = new Date();
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
        return now.toISOString().slice(0, 16);
    }; 

        const [offset, setOffset] = useState(0);
        const limit = 20;
        const [hasMore, setHasMore] = useState(true);
        const [fromDate, setFromDate] = useState();
        const [toDate, setToDate] = useState();
        const [isLocked, setIsLocked] = useState(false);
        const [fy, setFy] = useState([]);
          const [validUpto, setValidUpto] = useState(null);
    
        const [financialRange, setFinancialRange] = useState({
            from_date: '',
            to_date: ''
        });


    const [formItems, setFormItems] = useState({
        type_acc: '',
        ref_doc: '',
        date: getTodayDateTime(),
        invoice: '',
        invoice_date: '',
        remark: 'By using this service, you agree to the terms and conditions.',
        party: '',
        grand_total: '',
        delivery: '',
        bill: '',
        grand_total: '',
        total_gst: "",
        sub_total: "",
        branchId:'',
        delivery:'',
    })

    const [formData, setFormData] = useState([
        {
            id: '',
            qty: '',
            name: "",
            rate: '',
            amount: '',
            gst: '',
        }
    ]);

    useEffect(() => {
            if (mode === "edit" && editData) {
                handleEdit(editData);   
            }
        }, [editData, mode]);


    const handleAddClick = () => {
        setShowForm(true);
    }


    const addRow = () => {
        setFormItems(prev => ({
            ...prev,
            additionalDetails: [
                ...(prev.additionalDetails || []),
                { id: Date.now(), type: "SGT" }
            ]
        }));
    };
   const deleteRow = (indexToRemove) => {
        const newExtra = (formItems.additionalDetails || []).filter(
            (_, idx) => idx !== indexToRemove
        );
        setFormItems((prev) => ({ ...prev, additionalDetails: newExtra }));
           recalcTotals(
    formData,
    newExtra,
    billDiscountValue,
    billDiscountType
);
    };

  const updateRowField = (id, field, value) => {
        setFormItems(prev => {
            const updated = (prev.additionalDetails || []).map(row => {
                if (row.id === id) {
                    const newRow = { ...row, [field]: value };

                    // Recalculate value2 if value1 changes
                    if (field === "value1") {
                        const numeric = parseFloat(value) || 0;

                        // Use current subTotal to calculate value2
                        newRow.value2 = ((numeric * (formData.reduce((sum, item) => sum + (item.baseAmount || 0), 0))) / 100).toFixed(2);
                    }

                    return newRow;
                }
                return row;
            });

            const newFormItems = { ...prev, additionalDetails: updated };


            recalcTotals( formData,updated, billDiscountValue, billDiscountType);

            return newFormItems;
        });
    };

    const companyState = (company?.state || "").trim().toLowerCase();
const partyState = (selectedParty?.state || "").trim().toLowerCase();

const isInterState = companyState !== partyState;

const recalcTotals = (
    items = [],
    extraRows = [],
    billDiscountValue = billDiscountPercent,
    discountType = billDiscountType
) => {

    const updatedItems = Array.isArray(items) ? items : [];
    const updatedExtra = Array.isArray(extraRows) ? extraRows : [];

    // 1. Total Item Amount
    const subTotal = updatedItems.reduce((sum, item) => {
        return sum + (Number(item.baseAmount) || 0);
    }, 0);

    // 2. Item Discount
    const totalDiscount = updatedItems.reduce((sum, item) => {
        return sum + (Number(item.discountAmount) || 0);
    }, 0);

    const itemNetAmount = subTotal - totalDiscount;

    // 3. Bill Discount
    let billDiscountAmount = 0;

    if (discountType === "percent") {
        billDiscountAmount =
            (itemNetAmount * Number(billDiscountValue || 0)) / 100;
    } else {
        billDiscountAmount = Number(billDiscountValue || 0);

        if (billDiscountAmount > itemNetAmount) {
            billDiscountAmount = itemNetAmount;
        }
    }

    // 4. Amount after all discounts
    const discountedAmount = itemNetAmount - billDiscountAmount;

    let totalExtraCharges = 0;
    let totalExtraGST = 0;

    updatedExtra.forEach((row) => {

        let chargeAmount = Number(row.value2) || 0;

        if (row.chargeType === "percent") {
            chargeAmount =
                (discountedAmount * chargeAmount) / 100;
        }

        totalExtraCharges += chargeAmount;

        const gstPercent = Number(row.gst) || 0;

        const gstAmount =
            (chargeAmount * gstPercent) / 100;

        totalExtraGST += gstAmount;

    });

    setExtraChargesTotal(totalExtraCharges.toFixed(2));

    let totalGST = 0;

    updatedItems.forEach((item) => {

        const itemAmount =
            Number(item.discountedAmount ?? item.baseAmount) || 0;

        const ratio =
            itemNetAmount > 0
                ? itemAmount / itemNetAmount
                : 0;

     const taxableItemAmount =
    discountedAmount * ratio;

        const gstPercent =
            Number(item.tax) || 0;

        const gst =
            (taxableItemAmount * gstPercent) / 100;

        totalGST += gst;

    });


    let cgst = 0;
    let sgst = 0;
    let igst = 0;

const finalGST = totalGST + totalExtraGST;

if (isInterState) {

    igst = finalGST;

} else {

    cgst = finalGST / 2;
    sgst = finalGST / 2;

}


    const grandTotal =
    discountedAmount +
    totalExtraCharges +
    totalExtraGST +
    totalGST;

    // const roundOff =
    //     Math.round(grandTotal) - grandTotal;

    
    setSubTotal(subTotal.toFixed(2));

    setTotalDiscount(totalDiscount.toFixed(2));

    setBillDiscountAmount(billDiscountAmount.toFixed(2));

    setAfterBillDiscountAmount(discountedAmount.toFixed(2));

setPayableAmount(
    discountedAmount.toFixed(2)
);

    setCgst(cgst.toFixed(2));
    setSgst(sgst.toFixed(2));
    setIgst(igst.toFixed(2));


    setTotalTax(finalGST.toFixed(2));

    // setGrandTotal(grandTotal.toFixed(2));

    // setRoundOff(roundOff.toFixed(2));

    const roundedGrandTotal = Math.round(grandTotal);

const roundOff = roundedGrandTotal - grandTotal;

setGrandTotal(roundedGrandTotal.toFixed(2));
setRoundOff(roundOff.toFixed(2));

};


    const handleDeleteItem = (indexToRemove) => {
        const newItems = formData.filter((_, idx) => idx !== indexToRemove);
        const currentExtra = formItems.additionalDetails || [];

        recalcTotals(
    newItems,
    currentExtra,
    billDiscountValue,
    billDiscountType
);

        setFormData(newItems);
    };


    const handleFormItemChange = (index, field, value) => {
        const updatedItems = [...formData];

        updatedItems[index][field] = value;
        
        const qty = parseFloat(updatedItems[index].qty) || 0;
        const rate = parseFloat(updatedItems[index].rate) || 0;
        const taxPercent = parseFloat(updatedItems[index].tax) || 0;
        const discountPercent = parseFloat(updatedItems[index].discount) || 0;

    

        // Before discount
        const baseAmount = qty * rate;

        // Discount calculation
        const discountAmount = parseFloat(
            ((baseAmount * discountPercent) / 100).toFixed(2)
        );

        // After discount
        const discountedAmount = baseAmount - discountAmount;

        // GST calculation after discount
        const taxAmount = parseFloat(
            ((discountedAmount * taxPercent) / 100).toFixed(2)
        );

        // Final amount
        const totalAmount = parseFloat(
            (discountedAmount + taxAmount).toFixed(2)
        );

        updatedItems[index].baseAmount = baseAmount;
        updatedItems[index].discountAmount = discountAmount;
        updatedItems[index].discountedAmount = discountedAmount;
        updatedItems[index].taxAmount = taxAmount;
        updatedItems[index].amount = totalAmount;

        setFormData(updatedItems);

        recalcTotals(
    updatedItems,
    formItems?.additionalDetails || [],
    billDiscountValue,
    billDiscountType
);
    };



    const handleSelectDoc = (selectedOption) => {
        if (!selectedOption?.fullData) return;

        const q = selectedOption.fullData;
        setSelectedDoc(selectedOption);


        const additionalDetails = (q.additional_charges || []).map(c => ({
            ...c,
            value2: Number(c.value2) || 0
        }));


        const itemsData = (q.items || []).map(item => {
            const qty = Number(item.qty) || 0;
            const rate = Number(item.rate) || 0;

            // ✅ Numeric value for calculation
            const taxNumber = Number(item.tax?.toString().replace("%", "")) || 0;

            // ✅ Display value exactly as backend sent
            const taxDisplay = item.tax?.toString() || "0%";

            const baseAmount = qty * rate;
            const taxAmount = parseFloat(((baseAmount * taxNumber) / 100).toFixed(2));
            const amount = Number(item.amount || (baseAmount + taxAmount).toFixed(2));

            return {
                ...item,
                qty,
                rate,
                tax: taxNumber,
                taxDisplay,
                baseAmount,
                taxAmount,
                amount
            };
        });


        const subTotal = itemsData.reduce((s, i) => s + i.baseAmount, 0);
        const totalGst = itemsData.reduce((s, i) => s + i.taxAmount, 0);

        const chargesTotal = additionalDetails.reduce(
            (sum, c) =>
                c.type?.toLowerCase() === "discount"
                    ? sum - c.value2
                    : sum + c.value2,
            0
        );

        const grandTotal = subTotal + totalGst + chargesTotal;


        // setFormItems(prev => ({
        //     ...prev,
        //     ref_doc: q.ref_doc,
        //     party: q.party_id,
        //     partyName: q.party_name,
        //     cust_enq: q.cust_enq,
        //     quotation_date: q.enquiry_date,
        //     sale_person: q.sale_person,
        //     technician: q.technician,
        //     description: q.description,
        //     remark: q.remark,
        //     file: q.file,
        //     delivery:q.delivery,
        //     additionalDetails,
        //     grandTotal
        // }));

                  setFormItems(prev => ({
    ...prev,

    ref_doc: q.ref_doc,
    party: q.party_id,
    partyName: q.party_name,
    cust_enq: q.cust_enq,
    quotation_date: q.enquiry_date,
    sale_person: q.sale_person,
    technician: q.technician,
    description: q.description,
    remark: q.remark,
    file: q.file,
    delivery: q.delivery,

    additionalDetails,

    bill_discount_type: q.bill_discount_type,
    bill_discount_value: q.bill_discount_value,
    bill_discount_amount: q.bill_discount_amount,

    taxable_amount: q.taxable_amount,
    total_gst: q.total_gst,
    cgst: q.cgst,
    sgst: q.sgst,
    igst: q.igst,
    round_off: q.round_off,
    grand_total: q.grand_total
}));

        setFormData(itemsData);
        // setSubTotal(subTotal);
        // setTotalTax(totalGst);
        // setGrandTotal(grandTotal);

            setBillDiscountType(q.bill_discount_type || "percent");
setBillDiscountValue(Number(q.bill_discount_value || 0));
setBillDiscountAmount(Number(q.bill_discount_amount || 0));
setPayableAmount(Number(q.taxable_amount || 0));
setSubTotal(Number(q.sub_total || 0));
setTotalTax(Number(q.total_gst || 0));
setCgst(Number(q.cgst || 0));
setSgst(Number(q.sgst || 0));
setIgst(Number(q.igst || 0));
setRoundOff(Number(q.round_off || 0));
setGrandTotal(Number(q.grand_total || 0));
    };


    const handleGstChange = (value, index) => {
        const updated = [...formData];

        updated[index].tax = value;

        const taxPercent = parseFloat(value) || 0;
        const qty = parseFloat(updated[index].qty) || 0;
        const rate = parseFloat(updated[index].rate) || 0;
        const discountPercent = parseFloat(updated[index].discount) || 0;


        // Before discount
        const baseAmount = qty * rate;

        // Discount calculation
        const discountAmount = parseFloat(
            ((baseAmount * discountPercent) / 100).toFixed(2)
        );

        // After discount
        const discountedAmount = baseAmount - discountAmount;


        // GST after discount
        const gstAmount = parseFloat(
            ((discountedAmount * taxPercent) / 100).toFixed(2)
        );


        const amount = parseFloat(
            (discountedAmount + gstAmount).toFixed(2)
        );


        updated[index].baseAmount = baseAmount;
        updated[index].discountAmount = discountAmount;
        updated[index].discountedAmount = discountedAmount;
        updated[index].taxAmount = gstAmount;
        updated[index].amount = amount;


        setFormData(updated);

        recalcTotals(
    updated,
    formItems?.additionalDetails || [],
    billDiscountValue,
    billDiscountType
);
    };


       useEffect(() => {
        if ( formData.length || formItems?.additionalDetails?.lengt ) {
            recalcTotals(
                formData,
                formItems?.additionalDetails || [],
                billDiscountValue,
                billDiscountType
            );
    
        }
    
    }, [formData, formItems?.additionalDetails, billDiscountValue, billDiscountType]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormItems(prev => ({
            ...prev,
            [name]: value
        }));


    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileSizeInMB = file.size / (1024 * 1024);
            if (fileSizeInMB > 2) {

                showToast("File size is too large! Please upload a file smaller than 2MB.", 'danger')
                return;
            }
            setFiles(prevFiles => ({ ...prevFiles, [e.target.name]: file }));
        }
    };


    const handleEdit = async (form) => {
    const locked = isVoucherLocked(form.date);
              setIsLocked(locked);
        setIsEditMode(true);


        let parsedItems = [];
        try {
            if (form.items) {
                parsedItems = JSON.parse(form.items);
            }
        } catch (err) {
            console.error("Invalid JSON for items:", form.items, err);
            parsedItems = [];
        }
          parsedItems = parsedItems.map((item) => {

        const qty =Number(item.qty) || 0;
        const rate =  Number(item.rate) || 0;
        const tax = Number(item.tax) || 0;
        const discount = Number(item.discount) || 0;
        const baseAmount =  qty * rate;
        const discountAmount = Number(  ((baseAmount * discount) / 100).toFixed(2))
        const discountedAmount = baseAmount - discountAmount;

      const taxAmount = Number( ((discountedAmount * tax) / 100).toFixed(2) );

 const totalAmount = Number( (discountedAmount + taxAmount).toFixed(2));
return {
 ...item,
    hsn: item.hsn || "",
    qty,
            rate,
            tax,
            discount,
            baseAmount,
            discountAmount,
            discountedAmount,
            taxAmount,
            amount: totalAmount

        };

    });

        setFormData(parsedItems);


        let parsedAdditionalDetails = [];
    try {
     parsedAdditionalDetails =JSON.parse( form.additional_charges || "[]" );

    } catch (err) {
        console.log(
            "Invalid JSON for additional_charges:",
            err
        )
        parsedAdditionalDetails = [];
    }


     setBillDiscountType(
        form.bill_discount_type || "percent"
    );

    setBillDiscountValue(
        form.bill_discount_value || 0
    );


    setBillDiscountAmount(
        Number(
            form.bill_discount_amount || 0
        ).toFixed(2)
    );

     recalcTotals(
        parsedItems,
        parsedAdditionalDetails,
        Number(form.bill_discount_value) || 0,
        form.bill_discount_type || "percent"
    );


        const subTotal = parsedItems.reduce(
            (sum, item) => sum + (item.baseAmount || 0),
            0
        );

        const totalGst = parsedItems.reduce(
            (sum, item) => sum + (item.taxAmount || 0),
            0
        );

        const chargesTotal = parsedAdditionalDetails.reduce((sum, item) => {
            const value = Number(item.value2) || 0;
            return item.type?.toLowerCase() === "discount"
                ? sum - value
                : sum + value;
        }, 0);

        const grandTotal = subTotal + totalGst + chargesTotal;


        setSubTotal(subTotal.toFixed(2));
        setTotalTax(totalGst.toFixed(2));
        setGrandTotal(grandTotal.toFixed(2));

     


        setFormItems({
            id: form.id || "",
            ref_doc: form.ref_doc || "",
            date: form.date || "",
            remark: form.remark || "",
            party: form.party || "",
            partyName: form.party_name || "",
            delivery: form.delivery || "",
            bill: form.bill || "",
            invoice: form.invoice || '',
            invoice_date: formatDateTimeLocal(form.invoice_date),
            // invoice_date:form.invoice_date,
            inv_no: form.inv_no || "",              
  branchId: form.branchId || "", 
            additionalDetails: parsedAdditionalDetails.map((item, index) => ({
                id: item.id || index,
                type: item.type || "",
                value1: item.value1 || "",
                value2: item.value2 || "",

                        gst: Number(item.gst) || 0,
    charge_amount: Number(item.charge_amount) || 0,
    gst_amount: Number(item.gst_amount) || 0,
    taxable:  item.taxable ?? false
            }))
        });


        let filteredOptions = purchaseData
            .filter(e => e.type_acc?.toLowerCase() === "Purchase" &&
                String(e.party_id) === String(form.party))
            .map(e => ({
                value: e.id,
                label: `PU/${e.inv_no}/${e.branchId}`,
                fullData: e
            }));


        const matchingRefDocOption = purchaseData
            .find(e => String(e.id) === String(form.ref_doc));

        if (matchingRefDocOption && !filteredOptions.some(o => o.value === matchingRefDocOption.id)) {
            filteredOptions.push({
                value: matchingRefDocOption.id,
                label: `PU/${matchingRefDocOption.inv_no}/${matchingRefDocOption.branchId}`,
                fullData: matchingRefDocOption
            });
        }


        ;

     if (matchingRefDocOption) {
    setSelectedDoc({
        value: matchingRefDocOption.id,
        label: `PU/${matchingRefDocOption.inv_no}/${matchingRefDocOption.branchId}`,
        fullData: matchingRefDocOption
    });
} else {
    setSelectedDoc(null);
}


        setFiles({ file: form.file || null });


        setEditingCompanyId(form.id);
        setShowForm(true);
    };

   const formatDateTimeLocal = (dateStr) => {
            if (!dateStr) return "";


            let [datePart, timePart] = dateStr.split(" ");
            if (!timePart) timePart = "00:00";
            else timePart = timePart.slice(0, 5);

            return `${datePart}T${timePart}`;
        };


    const handleSelectChange = (e) => {
        const id = e.target.value;
        if (!id) return;
        const selectedItem = items.find((i) => i.id == id);
        if (!selectedItem) return;
         setFormData((prev) => [
            ...prev,
            {
                id: selectedItem.id,
                name: selectedItem.name,
                qty: 0,
                rate: selectedItem.rate || 0,
                amount: "",
                tax: 0,
                hsn:selectedItem.hsn || 0,

            },
        ]);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        const sendData = new FormData();
        sendData.append("type_acc", "Return");
        sendData.append("date", formItems.date || new Date().toISOString().split("T")[0]);
        // sendData.append("ref_doc", selectedDoc?.value || "");

         sendData.append("ref_doc", selectedDoc?.fullData?.id || "");
        sendData.append("invoice", formItems.invoice);
        sendData.append("invoice_date", formItems.invoice_date);
        sendData.append("remark", formItems.remark);
        sendData.append("party", formItems.party);
        sendData.append("grand_total", grandTotal);
        sendData.append("total_gst", totalTax);
        sendData.append("sub_total", subTotal);
           sendData.append("branchId", branchDetail.code);
          sendData.append("delivery", formItems.delivery);  


        if (formItems.bill !== undefined && formItems.bill !== "") {
            sendData.append("bill", formItems.bill);
        }


          if (formItems.invoice !== undefined && formItems.invoice !== "") {
            sendData.append("invoice", formItems.invoice);
        }

        if (formItems.invoice_date !== undefined && formItems.invoice_date !== "") {
            sendData.append("invoice_date", formItems.invoice_date);
        }


         sendData.append("taxable_amount", payableAmount);
        sendData.append("cgst", cgst);
        sendData.append("sgst", sgst);
        sendData.append("igst", igst);
        sendData.append("round_off", roundOff);
        sendData.append("is_inter_state", isInterState ? 1 : 0);
        sendData.append("bill_discount_type", billDiscountType);
sendData.append("bill_discount_value", billDiscountValue);
sendData.append("bill_discount_amount", billDiscountAmount);
sendData.append("discounted_taxable_amount", payableAmount);
sendData.append("gst_amount", totalTax);
sendData.append("extra_charges_total",extraChargesTotal);


        if (files.file) {
            const maxSizeMB = 2;
            const fileSizeMB = files.file.size / (1024 * 1024);
            if (fileSizeMB > maxSizeMB) {
                showToast(`File size exceeds ${maxSizeMB}MB!`, 'danger');
                return;
            }
            sendData.append("file", files.file);
        }



        const validItems = formData
            .filter(item => item.name && item.name.trim() !== "")
            .map(item => {

                const qty = Number(item.qty) || 0;
                const rate = Number(item.rate) || 0;
                const gstPercent = Number(item.tax) || 0;
                const discountPercent = Number(item.discount) || 0;
                const baseAmount = qty * rate;
                const discountAmount = Number(
                    ((baseAmount * discountPercent) / 100).toFixed(2)
                );
                const taxableAmount = baseAmount - discountAmount;
                const gstAmount = Number(
                    ((taxableAmount * gstPercent) / 100).toFixed(2)
                );
                const totalAmount = Number(
                    (taxableAmount + gstAmount).toFixed(2)
                );


                return {
                    id: item.id,
                    name: item.name,
                    qty,
                    rate,
                   baseAmount,
                    tax: gstPercent,
                     hsn: item.hsn || "", 

                    // discount details
                    discount: discountPercent,
                    discountAmount,
                    taxableAmount,

                    gstAmount,
                    totalAmount
                };
            });

        sendData.append("items", JSON.stringify(validItems));



   sendData.append(
    "additional_charges",
    JSON.stringify(
        (formItems.additionalDetails || []).map((row) => {

            let chargeAmount = Number(row.value2) || 0;

            if (row.chargeType === "percent") {
                chargeAmount =
                    (Number(payableAmount) * chargeAmount) / 100;
            }

            const gstPercent = Number(row.gst) || 0;

            const gstAmount =
                (chargeAmount * gstPercent) / 100;

            return {
                id: row.id || null,

                type: row.type,

                charge_type: row.chargeType || "amount",

                value1: Number(row.value1) || 0,

                value2: Number(row.value2) || 0,

                // Actual charge amount
                charge_amount: Number(chargeAmount.toFixed(2)),

                // GST Percentage
                gst: gstPercent,

                // GST Amount
                gst_amount: Number(gstAmount.toFixed(2)),

                taxable: false
            };

        })
    )
);




        try {

            if (isEditMode && editingCompanyId) {
                sendData.append("edit_by", adminData.user.id);

                const res = await axios.put(
                    `https://api.skyguard.group/api/update-purchase-return/${editingCompanyId}`,
                    sendData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );
               fetchReturnDetail(financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            0);
                showToast(" Return Updated Successfully!", "success");
                resetForm();
            } else {
                sendData.append("added_by", adminData.user.id);

                const res = await axios.post(
                    "https://api.skyguard.group/api/add-purchase-return",
                    sendData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );
                fetchReturnDetail(financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            0);
                showToast(" Return Added Successfully!", "success");
                resetForm();
            }

            resetForm();


           setIsEditMode(false)
            showToast('Return updated successfully!', 'success');
            setShowForm(false);
        } catch (err) {
            console.error("❌ Error:", err.response?.data || err.message);
            showToast('Failed to update Purchase!', 'danger');
        }
    };


    useEffect(() => {

        fetchBranchDetail();
       fetchYearDetail();
        fetchChargeDetail();
        // fetchOrderDetail();
        fetchPartyDetail();
        // fetchQuoationDetail();
        fetchInventoryDetail();
        fetchPurchaseDetail();
      
        fetchCompany();
    }, []);

 const fetchCompany = async () => {
        setLoading(true)
        try {
          const res = await axios.get(`https://api.skyguard.group/api/fetch-company-localData/${companyID}`);
          setCompany(res.data);
    
        } catch (error) {
          console.log(error)
        } finally {
          setLoading(false);
        }
      };

    const fetchPartyDetail = async () => {
        try {
            const resParty = await axios.get("https://api.skyguard.group/api/fetch-party-bill");

            // transform result into { value, label }
            const options = resParty.data.map((p) => ({
                value: p.id,
                label: p.name,
                phone: p.phone,
                address: p.address,
                  state: p.state
            }));


            setPartyOptions(options);

        } catch (error) {
            console.log(error);
        }
    };

    const fetchInventoryDetail = async () => {
        setLoading(true)
        try {
            const resInventory = await axios.get('https://api.skyguard.group/api/fetch-inventory');
            const items = resInventory.data.result || [];
            setItems(items);
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

    const fetchChargeDetail = async () => {
        setLoading(true)
        try {
            const response = await axios.get('https://api.skyguard.group/api/fetch-master-charge');
            setChargeMaster(response.data);
            const options = response.data.map((item) => ({
                value: item.charge_name,
                label: item.charge_name
            }));

            setChargeOptions(options);

        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

  const fetchBranchDetail = async () => {
        setLoading(true)
        try {
            const branchRes = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
            setBranchDetail(branchRes.data)
            return branchRes.data.code;
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

 const fetchYearDetail = async () => {
        setLoading(true);
        try {
            const branchCode = await fetchBranchDetail();
            const res = await axios.get(
                `https://api.skyguard.group/api/fetch-financial-year-localData/${financialYear}`
            );
            const yearData = res.data;
            setFy(yearData);
            // setIsLocked(yearData.is_locked === 1);

                      setValidUpto(yearData.valid_up_to);
                let shouldLock = false;

        // First check is_locked
        if (Number(yearData.is_locked) === 1) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const validUptoDate = new Date(yearData.valid_up_to);
            validUptoDate.setHours(0, 0, 0, 0);

            // Lock only if valid_up_to date has passed
            shouldLock = validUptoDate <= today;
        }

        setIsLocked(shouldLock);

            setFinancialRange({
                from_date: yearData.from_date,
                to_date: yearData.to_date
            });

            await fetchReturnDetail(
                yearData.from_date,
                yearData.to_date,
                branchCode,

            );
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };


const isVoucherLocked = (paymentDate) => {
    if (!validUpto || !paymentDate) return false;
    const voucherDate = new Date(paymentDate);
    voucherDate.setHours(0, 0, 0, 0);
    const fyValidUpto = new Date(validUpto);
    fyValidUpto.setHours(0, 0, 0, 0);
    return voucherDate <= fyValidUpto;
};

    const fetchPurchaseDetail = async () => {
        setLoading(true);
        try {
            const res = await axios.get("https://api.skyguard.group/api/fetch-purchase");


            const normalized = (res.data || []).map(e => ({
        ...e,
        items: typeof e.items === "string" ? JSON.parse(e.items) : e.items || [],
        additional_charges: typeof e.additional_charges === "string"
          ? JSON.parse(e.additional_charges)
          : e.additional_charges || []
      }));

      setPurchaseData(normalized);



        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };


     const fetchReturnDetail = async (fromDate,
        toDate,
        branchCode,
        newOffset = 0) => {
        setLoading(true);

           if (!branchCode) {
            console.log("Branch code missing");
            return;
        }
        try {
          const resPurchase = await axios.get("https://api.skyguard.group/api/fetch-purchase-return",
 {
                    params: {
                        from_date: fromDate,
                        to_date: toDate,
                        branch_code: branchCode,
                        limit: limit,
                        offset: newOffset
                    }
                }

          );
    
          const data = Array.isArray(resPurchase.data)
            ? resPurchase.data
            : resPurchase.data?.data || [];

            console.log(data)
    
      
         const returnOnly = data
            .filter(item => item.type_acc === "Return")
            .sort((a, b) =>  new Date(b.date) - new Date(a.date)); 
        // setFetchReturn(returnOnly)

          const result = returnOnly;
            if (newOffset === 0) {
                setFetchReturn(result);
                setHasMore(true);
            }

            else {
                setFetchReturn(prev => {
                    const merged = [...prev, ...result];

                    // optional: remove duplicates (safety)
                    const unique = Array.from(
                        new Map(merged.map(item => [item.id, item])).values()
                    );

                    return unique;
                });
            }

            // check if more data exists
            if (result.length < limit) {
                setHasMore(false);
            }
   
    
        } catch (error) {
          console.log(error);
        } finally {
          setLoading(false);
        }
      };

    const usedRefDocs = new Set(
        (fetchReturn || [])
            .filter(p => p.ref_doc)
            .map(p => String(p.ref_doc))
    );



        const currentParty =
    isEditMode ? formItems.party : selectedParty?.value;


 const refDocOptions = purchaseData
    .filter(e =>
        e.type_acc?.toLowerCase() === "purchase" &&
        String(e.party_id) === String(currentParty) &&
        !usedRefDocs.has(String(e.id))
    )
    .map(e => ({
        value: e.id,
        label: `PQ/${e.inv_no}/${e.branchId}`,
        fullData: e
    }));




    const normalizedSearch = (search ?? "").toLowerCase();

    const filtered = partyOptions.filter((p) => {
        return (
            p.label?.toLowerCase().includes(normalizedSearch) ||
            p.phone?.toLowerCase().includes(normalizedSearch) ||
            p.address?.toLowerCase().includes(normalizedSearch)
        );
    });


    const resetForm = () => {
        setFormItems({
            type_acc: '',
            ref_doc: '',
            date:getTodayDateTime(),
            invoice: '',
            invoice_date: '',
            remark: 'By using this service, you agree to the terms and conditions.',
            party: '',
            grand_total: '',
            edit_by: '',
            edit_date: '',
            added_by: '',
        });

        setFormData([]);

        setSubTotal([]);
        setTotalTax([]);
        setGrandTotal([]);

        setFiles({});
        setShowForm(false);
        setSelectedDoc([]);
          setBillDiscountType([]);
        setBillDiscountValue([]);
    };

    const formatDateTime = (datetime) => {
        if (!datetime) return "";
        const [date, time] = datetime.split(" ");
        const [year, month, day] = date.split("-");
        return `${day}-${month}-${year} ${time}`;
    };


    const filteredData = fetchReturn.filter(itm =>
        Object.values(itm).some(val =>
            String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
    );


    const [files, setFiles] = useState({
        file: null,

    })


  const handleViewQuotation = (quotation) => {
    if (!quotation) {
      console.warn("No Enquiry passed to handleViewQuotation()");
      return;
    }

    setSelectedQuotation(quotation);
    setShowDownloadModal(true);
  };

  const exportInvoiceToPDF = (selectedQuotation) => {
    const doc = new jsPDF("p", "mm", "a4");
    let currentY = 15;

    /* ================= HEADER ================= */
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text("STAR SIGNATURE SERVICES", 14, currentY);

    currentY += 6;

    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");

    const addressText =
      "A-8 JAI ISH KRUPA CHS LTD. ANAND NAGAR OPP AL-NOOR MASZID VASAI W 401202 THANE MUMBAI MAHARASHTRA BRANCH: DADAR, THANE, PUNE, AURANGABAD, GOA PANJIM";

    doc.text(doc.splitTextToSize(addressText, 180), 14, currentY);
    currentY += 12;

    doc.text("Phone: 9209206677 / 9209203355 / 9324004632", 14, currentY);
    currentY += 4;
    doc.text("Email: starsignatureservices@gmail.com", 14, currentY);
    currentY += 4;
    doc.text("GSTIN: 27ADYPY53133M2ZH", 14, currentY);

    currentY += 8;
    doc.line(14, currentY, 196, currentY);
    currentY += 6;

    /* ================= CUSTOMER DETAILS ================= */

    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text("Customer Detail", 14, currentY);
    currentY += 4;

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");

    const leftX = 14;
    const rightX = 105;
    const columnWidth = 90;


    doc.text(`Name: ${selectedQuotation.party_name}`, leftX, currentY);
    currentY += 5;
    doc.text(`Contact: ${selectedQuotation.party_phone}`, leftX, currentY);
    currentY += 5;
    doc.text(`Bill By: ${selectedQuotation.added_first_name || ""} ${selectedQuotation.added_middle_name || ""} ${selectedQuotation.added_last_name || ""}`, leftX, currentY);
    currentY += 5;
    doc.text(`Date: ${selectedQuotation.date}`, leftX, currentY);


    let addressY = currentY - 19;


    const billingLines = doc.splitTextToSize(selectedQuotation.bill || "-", columnWidth);
    doc.text("Billing Address:", rightX, addressY);
    doc.text(billingLines, rightX, addressY + 4);


    addressY += billingLines.length * 5 + 4;
    const deliveryLines = doc.splitTextToSize(selectedQuotation.delivery || "-", columnWidth);
    doc.text("Delivery Address:", rightX, addressY);
    doc.text(deliveryLines, rightX, addressY + 4);
  
    addressY += deliveryLines.length * 5 + 4;
doc.text(`Invoice No.: ${selectedQuotation.invoice || "-"}`, rightX, addressY);

// Invoice Date
addressY += 5;
doc.text(`Invoice Date: ${selectedQuotation.invoice_date || "-"}`, rightX, addressY);

    currentY = Math.max(currentY, addressY + deliveryLines.length * 5 + 5);


    /* ================= ITEMS TABLE ================= */
    const items = selectedQuotation.items
      ? JSON.parse(selectedQuotation.items)
      : [];

    autoTable(doc, {
      startY: currentY,
      theme: "grid",
      styles: { fontSize: 10 },
      head: [["Item Name", "Qty", "Rate", "GST", "Amount"]],
      body: items.map(it => [
        it.name,
        it.qty,
        it.rate,
        it.tax,
        it.amount
      ])
    });

    currentY = doc.lastAutoTable.finalY + 5;

    /* ================= ADDITIONAL DETAILS ================= */
    const additionalDetails = selectedQuotation.additional_charges
      ? JSON.parse(selectedQuotation.additional_charges)
      : [];

    if (additionalDetails.length > 0) {
      autoTable(doc, {
        startY: currentY,
        theme: "grid",
        styles: { fontSize: 10 },
        head: [["Additional Detail", "", "", "", ""]],
        body: additionalDetails.map(row => [
          row.type,
          "",
          "",
          row.value1,
          row.value2
        ])
      });

      currentY = doc.lastAutoTable.finalY + 6;
    }

    /* ================= TOTALS (RIGHT SIDE, NO CALCULATION) ================= */

    const cleanNumber = (val) =>
      val ? Number(String(val).replace(/,/g, "")) : 0;

    const subTotal = cleanNumber(selectedQuotation.sub_total);
    const totalGST = cleanNumber(selectedQuotation.total_gst);
    const grandTotal = cleanNumber(selectedQuotation.grand_total);

    /* ================= TOTALS ================= */
    if (currentY > 250) {
      doc.addPage();
      currentY = 20;
    }

    const totalsX = 130;

    doc.setFont("helvetica", "normal");
    doc.text("Sub Total", totalsX, currentY);
    doc.text(` ${subTotal.toFixed(2)}`, 195, currentY, { align: "right" });


    currentY += 6;
    doc.text("Total GST", totalsX, currentY);
    doc.text(` ${totalGST.toFixed(2)}`, 195, currentY, { align: "right" });

    currentY += 6;
    doc.setFont("helvetica", "bold");
    doc.text("Grand Total", totalsX, currentY);
    doc.text(` ${grandTotal.toFixed(2)}`, 195, currentY, { align: "right" });

    /* ================= REMARK ================= */
    if (selectedQuotation.remark) {
      doc.setFont("helvetica", "bold");
      doc.text("Remark:", 14, currentY);
      currentY += 4;

      doc.setFont("helvetica", "normal");
      doc.text(
        doc.splitTextToSize(selectedQuotation.remark, 180),
        14,
        currentY
      );
    }

    /* ================= SAVE ================= */
    doc.save(
      `Invoice_${selectedQuotation.party_name || "Customer"}.pdf`
    );
  };


  const handlePrint = () => {
  const printContents = document.getElementById("invoice-print-area");

  const printWindow = window.open("", "_blank");

  printWindow.document.write(`
    <html>
      <head>
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"/>
        <style>
          body { margin: 10px; }
        </style>
      </head>
      <body></body>
    </html>
  `);

  printWindow.document.close();

  // ✅ Clone exact node (keeps structure better)
  const clonedContent = printContents.cloneNode(true);
  printWindow.document.body.appendChild(clonedContent);

  printWindow.focus();
  printWindow.print();
  printWindow.close();
};

    const handleLoadMore = () => {

        const nextOffset = offset + limit;
        setOffset(nextOffset);

        fetchReturnDetail(
            financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            nextOffset
        );
    };


     const thStyle = {
        border: "1px solid #000",
        padding: "8px",
        textAlign: "center",
        fontWeight: "bold",
    };

    const tdCenter = {
        border: "1px solid #000",
        padding: "6px",
        textAlign: "center",
    };

    const tdLeft = {
        border: "1px solid #000",
        padding: "6px",
        textAlign: "left",
    };

    const tdRight = {
        border: "1px solid #000",
        padding: "6px",
        textAlign: "right",
    };
    const summaryTitle = {
        border: "1px solid #000",
        padding: "8px",
        fontWeight: "bold",
    };

    const summaryValue = {
        border: "1px solid #000",
        padding: "8px",
        textAlign: "right",
    };


    const bankTitle = {
        border: "1px solid #000",
        padding: "8px",
        fontWeight: "bold",
        width: "35%",
    };

    const bankValue = {
        border: "1px solid #000",
        padding: "8px",
    };

    return (
        <div className='main-section'>
            <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                <ToastNotification
                    show={toast.show}
                    message={toast.message}
                    bg={toast.bg}
                    onClose={() => setToast({ ...toast, show: false })}
                />
                <h3 className='my-3 fw-bold fs-5 golos'>Purchase Return</h3>

                <div class="mb-3 row gx-3 gy-2 align-items-center  d-flex justify-content-between">
                    <div class="col-12 col-md-4">
                        <input
                            type="text"
                            class="form-control"
                            id="searchInput"
                              placeholder="Search ..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                       <div className="col-12 col-md-2 d-flex justify-content-end">
                                                <button
                                                    className={`btn ${showForm ? 'btn-danger' : 'btn-success'}`}
                                                    onClick={() => {
                                                        setShowForm(prev => !prev);
                    
                                                        if (showForm) {
                                                            setIsEditMode(false);
                                                            setEditingCompanyId(null);
                                                            resetForm();
                                                        }
                                                    }}
                                                >
                                                    {showForm ? (
                                                        <>
                                                            Close <FaTimes size={18} />
                                                        </>
                                                    ) : (
                                                        <>
                                                            Add <AiOutlinePlusCircle size={18} />
                                                        </>
                                                    )}
                                                </button>
                                            </div>
                </div>
                {/* form */}
                {showForm && (
                      <fieldset >
                             <div className='card p-3 my-3 shadow-sm bg-white border'>
                        <div className="row">

                            <div className="col-12">
                                                                   {isEditMode && (
  <div className="mb-3">
    <label>Document No:</label> <br />
    <span className="badge bg-primary px-3 py-2">
      {`PR/${formItems.inv_no}/${formItems.branchId}`}
    </span>
  </div>
)}
                                <div className="row g-3">

                                    <div className="col-12 col-md-4">
                                        <label className="form-label fw-medium">Select Party</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Choose Party..."
                                            value={formItems.partyName || ""}
                                            readOnly
                                            onClick={() => setShowPartyModal(true)}
                                            required
                                                 disabled={isEditMode && isLocked}
                                        />
                                    </div>

                                    <Modal show={showPartyModal} onHide={() => setShowPartyModal(false)} size="lg">
                                        <Modal.Header closeButton>
                                            <Modal.Title>Search Party</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Form.Control
                                                type="text"
                                                placeholder="Search by name, phone, or address"
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                                  ref={searchInputRef}
                                            />
                                             <div className="table-responsive mt-3">
                                                 <Table striped bordered hover className="mt-3">
                                                <thead>
                                                    <tr>
                                                         <th>Action </th>
                                                        <th>Name</th>
                                                        <th>Phone</th>
                                                        <th>Address</th>
                                                       
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filtered.map((p) => (
                                                        <tr key={p.value}>
                                                              <td className="text-center" style={{ width: "80px" }} >
                                                                <Button
                                                                    variant="primary"
                                                                    size="sm"

                                                                    onClick={() => {
                                                                        setSelectedParty(p);

                                                                        setFormItems((prev) => ({
                                                                            ...prev,
                                                                            party: p.value,
                                                                            partyName: p.label,
                                                                             delivery: p.address,
                                                                        }));


                                                                        setShowPartyModal(false);
                                                                         setUseDefaultShipping(true);
                                                                    }}

                                                                >
                                                                    Select
                                                                </Button>
                                                            </td>
                                                            <td>{p.label}</td>
                                                            <td>{p.phone}</td>
                                                            {/* <td>{p.address}</td> */}
                                                            <td
                                                                style={{
                                                                    maxWidth: "300px",
                                                                    whiteSpace: "normal",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                }}
                                                            >
                                                                {(p.address || "").length > 50
                                                                    ? `${(p.address || "").slice(0, 50)}...`
                                                                    : (p.address || "NA")}

                                                            </td>
                                                          
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>

                                             </div>
                                         
                                        </Modal.Body>
                                    </Modal>

                                    <div className="col-12 col-md-4">
                                        <label className="form-label fw-medium">Select Ref Doc</label>
                                        <Select
                                            options={refDocOptions}

                                            placeholder="Choose Ref Doc..."
                                            onChange={handleSelectDoc}
                                            value={selectedDoc}
                                              isDisabled={isEditMode &&  isLocked}
                                        />
                                    </div>

                                    <div className="col-12 col-md-4">
                                        <label htmlFor="attendanceDate" className="form-label fw-medium">Enter Date</label>
                                        <input type="datetime-local" className="form-control" id="attendanceDate" name="date"
                                            value={formItems.date || new Date().toISOString().split("T")[0]}
                                            onChange={handleChange}
                                               disabled={isEditMode && isLocked}
                                        />
                                    </div>

                                                                          <div className="col-12 col-md-4">
                    <div className="d-flex align-items-center gap-2 text-nowrap">
                      <label htmlFor="delivery" className="fw-medium mb-0">
                        Shipping Address
                      </label>

                      <input
                        type="checkbox"
                        className="form-check-input m-0"
                        id="editShipping"
                        checked={!useDefaultShipping}
                        onChange={() => setUseDefaultShipping(!useDefaultShipping)}
                           disabled={isEditMode && isLocked}
                      />

                      <span className="text-muted">Change Address</span>
                    </div>

                    <input
                      type="text"
                      className="form-control mt-1"
                      id="delivery"
                      name="delivery"
                      value={formItems.delivery || ""}
                      onChange={handleChange}
                      disabled={useDefaultShipping}
                         disabled={isEditMode && isLocked}
                    />
                  </div>

                                </div>
                            </div>
                     
                                                               <div className="table-responsive my-4">
                                                                                         <h5 className='golos'>Add New Item</h5>
                                                                                         <table className="table table-bordered text-center align-middle">
                                                                                             <thead className="table-primary">
                                                                                                 <tr>
                                                                                                     <th style={{ width: "220px" }}>Item Name</th>
                                                                                                     <th style={{ width: "80px" }}>Qty</th>
                                                                                                     <th style={{ width: "120px" }}>Rate</th>
                                                                                                     <th style={{ width: "80px" }}> Discount</th>
                                                                                                     <th style={{ width: "100px" }}>GST</th>
                                                                                                     <th style={{ width: "120px" }}>Tax Amount</th>
                                                                                                     <th style={{ width: "80px" }}>Action</th>
                                                                                                 </tr>
                                                                                             </thead>
                                                                                             <tbody>
                                                                                                 {formData.map((fi, idx) => (
                                                                                                     <tr key={idx}>
                                                                                                         <td>
                                                                                                             <input
                                                                                                                 type="text"
                                                                                                                 className="form-control"
                                                                                                                 value={fi.name}
                                                                                                                 onChange={(e) => handleFormItemChange(idx, 'name', e.target.value)}
                                                                                                                 placeholder="Item Name"
                                                                                                                 disabled={isEditMode && isLocked}
                                                                                                             />
                                                                                                         </td>
                                                                                                         <td>
                                                                                                             <input
                                                                                                                 type="number"
                                                                                                                 className="form-control "
                                                                                                                 value={fi.qty}
                                                                                                                 onChange={(e) => handleFormItemChange(idx, 'qty', e.target.value)}
                                                                                                                 placeholder="Qty"
                                                                                                                 disabled={isEditMode && isLocked}
                                                                                                             />
                                                                                                         </td>
                                                                                                         <td>
                                                                                                             <input
                                                                                                                 type="number"
                                                                                                                 className="form-control"
                                                                                                                 value={fi.rate}
                                                                                                                 onChange={(e) => handleFormItemChange(idx, 'rate', e.target.value)}
                                                                                                                 placeholder="Rate"
                                                                                                                 disabled={isEditMode && isLocked}
                                                                                                             />
                                                                                                         </td>
                                                                                                         <td>
                                                                                                             <input
                                                                                                                 type="number"
                                                                                                                 className="form-control"
                                                                                                                 value={fi.discount || ""}
                                                                                                                 placeholder="%"
                                                                                                                 onChange={(e) =>
                                                                                                                     handleFormItemChange(idx, "discount", e.target.value)
                                                                                                                 }
                                                                                                                 disabled={isEditMode && isLocked}
                                                                                                             />
                                                                                                         </td>
                                                         
                                                                                                         <td>
                                                                                                             <select
                                                                                                                 className="form-control"
                                                                                                                 value={fi.tax}      
                                                                                                                 onChange={(e) => handleGstChange(+e.target.value, idx)}
                                                                                                                 disabled={isEditMode && isLocked}
                                                                                                             >
                                                                                                                 <option value={0}>0%</option>
                                                                                                                 <option value={0.25}>0.25%</option>
                                                                                                                 <option value={3}>3%</option>
                                                                                                                 <option value={5}>5%</option>
                                                                                                                 <option value={12}>12%</option>
                                                                                                                 <option value={18}>18%</option>
                                                                                                                 <option value={28}>28%</option>
                                                                                                             </select>
                                                         
                                                                                                         </td>
                                                         
                                                         
                                                         
                                                                                                         <td>
                                                                                                             <input
                                                                                                                 type="text"
                                                                                                                 className="form-control"
                                                                                                                 value={fi.amount || ''}
                                                                                                                 readOnly
                                                                                                                 disabled={isEditMode && isLocked}
                                                                                                             />
                                                                                                         </td>
                                                         
                                                         
                                                                                                         <td>
                                                                                                             <button className="btn btn-danger btn-sm" onClick={() => handleDeleteItem(idx)} disabled={isEditMode && isLocked}>
                                                         
                                                         
                                                                                                                 <MdDeleteForever size={15} />
                                                                                                             </button>
                                                                                                         </td>
                                                         
                                                                                                     </tr>
                                                                                                 ))}
                                                                                             </tbody>
                                                                                             <tfoot>
                                                         
                                                                                                 <tr>
                                                         
                                                                                                 </tr>
                                                         
                                                                                                 <tr>
                                                                                                     <td colSpan="6" className="text-end fw-bold">
                                                                                                         Total Item Amount
                                                                                                     </td>
                                                                                                     <td>
                                                                                                         <input
                                                                                                             className="form-control"
                                                                                                             value={subTotal}
                                                                                                             readOnly
                                                                                                         />
                                                                                                     </td>
                                                                                                 </tr>
                                                         
                                                         
                                                                                                 <tr>
                                                                                                     <td colSpan="5" className="text-end fw-bold">
                                                                                                         Bill Discount
                                                                                                     </td>
                                                         
                                                                                                     <td>
                                                                                                         <select
                                                                                                             className="form-select"
                                                                                                             value={billDiscountType || "percent"}
                                                                                                             onChange={(e) => {
                                                         
                                                                                                                 const type = e.target.value;
                                                         
                                                                                                                 setBillDiscountType(type);
                                                         
                                                                                                                 recalcTotals(
                                                                                                                     formData,
                                                                                                                     formItems?.additionalDetails || [],
                                                                                                                     billDiscountValue || 0,
                                                                                                                     type
                                                                                                                 );
                                                         
                                                                                                             }}
                                                                                                             disabled={isEditMode && isLocked}
                                                                                                         >
                                                                                                             <option value="percent">%</option>
                                                                                                             <option value="amount">Amount</option>
                                                                                                         </select>
                                                                                                     </td>
                                                         
                                                         
                                                                                                     <td>
                                                                                                         <input
                                                                                                             type="number"
                                                                                                             className="form-control"
                                                                                                             value={billDiscountValue ?? ""}
                                                                                                             onChange={(e) => {
                                                         
                                                                                                                 const value = e.target.value;
                                                         
                                                                                                                 setBillDiscountValue(value);
                                                         
                                                                                                                 recalcTotals(
                                                                                                                     formData,
                                                                                                                     formItems?.additionalDetails || [],
                                                                                                                     value || 0,
                                                                                                                     billDiscountType || "percent"
                                                                                                                 );
                                                         
                                                                                                             }}
                                                                                                             disabled={isEditMode && isLocked}
                                                                                                         />
                                                                                                     </td>
                                                                                                 </tr>
                                                         
                                                                                                 <tr>
                                                                                                     <td colSpan="6" className="text-end fw-bold">
                                                                                                         Taxable Amount
                                                                                                     </td>
                                                                                                     <td>
                                                                                                         <input
                                                                                                             className="form-control"
                                                                                                             value={payableAmount}
                                                                                                             readOnly
                                                                                                         />
                                                                                                     </td>
                                                                                                 </tr>
                                                         
                                                         
                                                         
                                                         
                                                         
                                                         
                                                         
                                                         
                                                                                                 <tr className="text-end fw-bold">
                                                                                                     <td colSpan="7">
                                                                                                         <div className="d-flex justify-content-end mb-2">
                                                                                                             <button
                                                                                                                 type="button"
                                                                                                                 className="btn btn-primary btn-sm"
                                                                                                                 onClick={addRow}
                                                                                                                 disabled={isEditMode && isLocked}
                                                                                                             >
                                                                                                                 + Add Row
                                                                                                             </button>
                                                                                                         </div>
                                                                                                     </td>
                                                                                                 </tr>
                                                         
                                                                                                 {formItems.additionalDetails?.map((row, index) => (
                                                                                                     <tr key={row.id || index}>
                                                                                                         <td colSpan="7">
                                                                                                             <div className="d-flex justify-content-end align-items-center gap-2">
                                                                                                                 <Select
                                                                                                                     options={chargeOptions}
                                                                                                                     value={chargeOptions.find(option => option.value === row.type)}
                                                                                                                     onChange={(selected) => {
                                                         
                                                                                                                         const selectedCharge = chargeMaster.find(
                                                                                                                             (item) => item.charge_name === selected.value
                                                                                                                         );
                                                                                                                         updateRowField(row.id, "type", selected.value);
                                                                                                                         if (selectedCharge) {
                                                                                                                             updateRowField(row.id, "value1", selectedCharge.charge_mrp);
                                                                                                                         }
                                                                                                                     }}
                                                                                                                     placeholder="Select Charge"
                                                                                                                     hideSelectedOptions={false}
                                                                                                                     menuPortalTarget={document.body}
                                                                                                                     styles={{
                                                                                                                         container: base => ({ ...base, width: 150 }),
                                                                                                                         menuPortal: base => ({ ...base, zIndex: 9999 })
                                                                                                                     }}
                                                                                                                     isDisabled={isEditMode && isLocked}
                                                                                                                 />
                                                                                                                 <select
                                                                                                                     className="form-select w-auto"
                                                                                                                     style={{ minWidth: "120px" }}
                                                         
                                                                                                                     value={row.chargeType || "amount"}
                                                                                                                     onChange={(e) =>
                                                                                                                         updateRowField(
                                                                                                                             row.id,
                                                                                                                             "chargeType",
                                                                                                                             e.target.value
                                                                                                                         )
                                                                                                                     }
                                                                                                                 >
                                                                                                                     <option value="amount">
                                                                                                                         Amount
                                                                                                                     </option>
                                                         
                                                                                                                     <option value="percent">
                                                                                                                         %
                                                                                                                     </option>
                                                         
                                                                                                                 </select>
                                                         
                                                         
                                                         
                                                                                                                 <input
                                                                                                                     type="text"
                                                                                                                     className="form-control"
                                                                                                                     style={{ width: "120px" }}
                                                                                                                     value={row.value2 || ""}
                                                         
                                                                                                                     onChange={(e) => updateRowField(row.id, "value2", e.target.value)}
                                                                                                                     disabled={isEditMode && isLocked}
                                                                                                                 />
                                                         
                                                         
                                                                                                                 <select
                                                                                                                     className="form-select w-auto"
                                                                                                                     style={{ minWidth: "90px" }}
                                                                                                                     value={row.gst || 0}
                                                                                                                     onChange={(e) =>
                                                                                                                         updateRowField(row.id, "gst", Number(e.target.value))
                                                                                                                     }
                                                                                                                     disabled={isEditMode && isLocked}
                                                                                                                 >
                                                                                                                     <option value={0}>0%</option>
                                                                                                                     <option value={0.25}>0.25%</option>
                                                                                                                     <option value={3}>3%</option>
                                                                                                                     <option value={5}>5%</option>
                                                                                                                     <option value={12}>12%</option>
                                                                                                                     <option value={18}>18%</option>
                                                                                                                     <option value={28}>28%</option>
                                                                                                                 </select>
                                                         
                                                         
                                                                                                                 <button className="btn btn-danger btn-sm" onClick={() => deleteRow(index)} disabled={isEditMode && isLocked}>
                                                         
                                                                                                                     <MdDeleteForever size={20} />
                                                                                                                 </button>
                                                                                                             </div>
                                                                                                         </td>
                                                                                                     </tr>
                                                         
                                                                                                 ))}
                                                         
                                                         
                                                                                                 <tr>
                                                                                                     <td colSpan="6" className="text-end fw-bold">
                                                                                                         Total GST
                                                                                                     </td>
                                                                                                     <td>
                                                                                                         <input value={totalTax} readOnly className="form-control" />
                                                                                                     </td>
                                                         
                                                                                                 </tr>
                                                         
                                                                                                 <tr>
                                                                                                     <td colSpan="6" className="text-end fw-bold">
                                                                                                         Grand Total
                                                                                                     </td>
                                                                                                     <td>
                                                                                                         <input
                                                                                                             className="form-control"
                                                                                                             value={grandTotal}
                                                                                                             readOnly
                                                                                                         />
                                                                                                     </td>
                                                                                                 </tr>
                                                         
                                                                                             </tfoot>
                                                                                         </table>
                                                         
                                                                                     </div>

                        <div className="col-12 col-md-6 p-3">
                <label htmlFor="attachment" className='form-label fw-medium'>Attachment</label>
                <input
                  type="file"
                  className="form-control"
                  id="attachment"
                  name='file'
                  accept="image/*,application/pdf"
                  onChange={handleFileChange}
                     disabled={isEditMode && isLocked}                />

                {isEditMode && files.file && typeof files.file === "string" && (
                  <div className="mt-2">
                    <span>Previous file: </span>
                    <a href={`https://api.skyguard.group/uploads/${files.file}`} target="_blank" rel="noopener noreferrer">{files.file}</a>
                  </div>
                )}
              </div>


              <div className="col-12 col-md-6 p-3">
                <label htmlFor="description" className='form-label fw-medium'>Remark</label>
                <textarea
                  className="form-control"
                  id="description"
                  rows="5"
                  placeholder="Enter description here..."
                  name='remark'
                  value={formItems.remark}
                  onChange={handleChange}
                     disabled={isEditMode && isLocked}
                ></textarea>
              </div>

                        </div>



                        {/* Save/Cancel */}
                       <div className='gap-2 d-flex justify-content-center mt-4'>
              <button type="button" className='btn btn-success' onClick={handleSubmit}    disabled={isEditMode && isLocked}>{isEditMode ? "Update" : "Save"} </button>
              <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => { setShowForm(false); setIsEditMode(false); resetForm(); }}>
                Cancel
              </button>
            </div>
                    </div>
                      </fieldset>
                 
                )}

                {/* main-table */}
                <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                        <table className='table table-bordered table-striped table-hover text-center align-middle'>
                          <thead className='table-info'>
                            <tr>
                              <th scope='col'>SN</th>
                               <th scope='col' >Action</th>
                              <th scope='col' > PO No. </th>
                              <th scope='col'>Party Name</th>
                              <th scope='col'>Added By</th>
                              <th scope='col'>Added Date</th>
                              <th scope='col'>Edit By</th>
                              <th scope='col'>Edit Date</th>
              
                             
              
                            </tr>
                          </thead>
              
              
              
                          <tbody>
                            {filteredData.map((p, i) => (
                              <tr key={p.id}>
                                <td>{filteredData.length - i}</td>
                                     <td>
              
                                  <button
                                    className="btn btn-success"
              
                                    onClick={() => handleEdit(p)}
                                  >
                                    <CiEdit size={20} />
                                  </button>
                                    <button
                                                        className="btn btn-warning mx-1"
                                                        onClick={() => handleViewQuotation(p)}
                                  
                                  
                                                      >
                                                        <FaDownload size={20} />
                                                      </button>
                                </td>
                                <td>{`PR/${p.inv_no}/${branchDetail.code}/${fy.financial_year.split('-')[0]}`}</td>
              
                                <td>{p.party_name}</td>
                                <td>{p.added_first_name} {p.added_middle_name || ""} {p.added_last_name} </td>
                                <td>{formatDateTime(p.date)}</td>
                                <td>{p.edit_first_name} {p.edit_middle_name || ""} {p.edit_last_name} </td>
                                <td>{formatDateTime(p.edit_date)} </td>
              
                           
                              </tr>
                            ))}
                          </tbody>
               

    {/* {showDownloadModal && selectedQuotation && (() => {
              const parsedItems = selectedQuotation.items
                ? JSON.parse(selectedQuotation.items)
                : [];

              const parsedAdditionalDetails = selectedQuotation.additional_charges
                ? JSON.parse(selectedQuotation.additional_charges)
                : [];


              const headerImageUrl = `https://api.skyguard.group/uploads/${branchDetail.header_img}`;

              return (
                <div
                  className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                  style={{
                    backgroundColor: "rgba(0,0,0,0.5)",
                    zIndex: 9999,
                  }}
                >

                  <div
                    style={{
                      background: "#fff",
                      width: "90%",
                      maxWidth: "900px",
                      borderRadius: "8px",
                      padding: "20px",
                      maxHeight: "90vh",
                      overflowY: "auto",
                      position: "relative",
                    }}
                  >

                    <button
                      onClick={() => setShowDownloadModal(false)}
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        border: "none",
                        background: "transparent",
                        fontSize: "20px",
                        cursor: "pointer",
                      }}
                    >
                      ✖
                    </button>


         

                    <div id="invoice-print-area" style={{ position: "relative" }}>
                      <img
                        src={headerImageUrl}
                        alt="header"
                         style={{
                                                position: "absolute",
                                                top: "30%",
                                                left: "50%",
                                                width: "350px",
                                                height: "350px",
                                                opacity: "0.2",
                                                transform: "translate(-50%, -50%)",
                                                zIndex: "0",
                                            }}
                      />
                      <div style={{ position: "relative", zIndex: 1 }}>

                  

                      <h3 style={{ textAlign: "center", marginBottom: "5px" }}>Purchase Return</h3>




                      <table style={{ width: "100%", borderCollapse: "collapse" }} border="1">
                        <tbody >
                          <tr >
                            <td style={{ width: "60%", padding: "8px" }} className='text-start'>

                              <table style={{ width: "100%" }} >
                                <tbody>
                                  <tr>{company.name} </tr>
                                  <tr> {company.address} </tr>
                                  <tr>Phone: {company.phone} </tr>
                                  <tr> GSTIN: {company.gst} </tr>
                                  <tr>Email : {company.email} </tr>
                                  <tr>Pan : {company.pan} </tr>
                                </tbody>
                              </table>


                            </td>

                            <td style={{ width: "40%" }} >

                              <table style={{ width: "95%" }} className='text-start'>

                                <tbody >
               
                                  <tr>
                                    <td>Date</td>
                                    <td>{selectedQuotation.date}</td>
                                  </tr>
                                  <tr>
                                    <td>Shipping Address
                                    </td>
                                    <td>{selectedQuotation.delivery}</td>
                                  </tr>


                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>


                      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }} border="1">
                        <tbody>
                          <tr>
                            <td style={{ width: "50%", padding: "8px" }} className='text-start'>
                              <b>Party Detail:</b><br />
                              <table style={{ width: "100%" }} >
                                <tbody >
                                  <tr>{selectedQuotation.party_name} </tr>
                                  <tr> {selectedQuotation.party_address} </tr>

                                  <tr>{selectedQuotation.party_state} , {selectedQuotation.party_city} </tr>
                                  <tr> {selectedQuotation.party_region}, {selectedQuotation.party_pincode}  </tr>
                                  <tr>Phone: {selectedQuotation.party_phone} </tr>
                                  <tr>  Email: {selectedQuotation.party_email}</tr>
                                  <tr>  CIN No. :{selectedQuotation.party_cin}  </tr>
                                  <tr>  MSME :{selectedQuotation.party_msme} </tr>

                                </tbody>
                              </table>
                            </td>

                          </tr>
                        </tbody>
                      </table>


                      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }} border="1" className='table table-bordered table-striped table-hover text-center align-middle'>
                        <thead>
                          <tr>
                            <th>Sr No</th>
                            <th>Description of Goods</th>
                       
                            <th>Qty</th>
                     
        <th>Rate</th>
     
        <th>Amount</th> 
                          </tr>
                        </thead>

                        <tbody>
                          {parsedItems.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.name}</td>

                              <td>{item.qty}</td>
                          
          <td>{item.rate}</td>
       
          <td>{item.amount}</td> 
                            </tr>
                          ))}


                {parsedAdditionalDetails.length > 0 && (
  <>
    <tr>
      <td colSpan="5" style={{ textAlign: "left", fontWeight: "bold" }}>
        Additional Charges
      </td>
    </tr>

    {parsedAdditionalDetails.map((row, index) => (
      <tr key={index}>
        <td colSpan="4" style={{ textAlign: "right" }}>
          {row.type}
        </td>
        <td style={{ textAlign: "right" }}>
          {Number(row.value2 || 0).toFixed(2)}
        </td>
      </tr>
    ))}
  </>
)}

      <tr>
        <td colSpan="4" style={{ textAlign: "right" }}><b>Total</b></td>
        <td><b>{selectedQuotation.grand_total}</b></td>
      </tr>
                        </tbody>
                      </table>


                      <div style={{ marginTop: "5px", border: "1px solid #000", padding: "5px" }} className='text-start'>
                        <b>Amount Chargeable (In Words):</b> Rupees Only
                      </div>


                      <table
                        style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }}
                        border="1"
                      >
                        <tbody>
                          <tr>

                       
                            <td style={{ width: "50%", padding: "8px", verticalAlign: "top" }}>

                              <div style={{ border: "1px solid #000", padding: "8px" }}>
                                <b>Company Bank Details:</b>

                                <table style={{ width: "100%", marginTop: "5px" }} className='table table-bordered table-striped table-hover text-center align-middle'>
                                  <tbody>
                                    <tr>
                                      <td>Bank Name</td>
                                      <td>{company.bank_name} </td>
                                    </tr>
                                    <tr>
                                      <td>Account No</td>
                                      <td>{company.acc_no}  </td>
                                    </tr>
                                    <tr>
                                      <td>IFSC Code</td>
                                      <td>{company.ifsc} </td>
                                    </tr>
                                    <tr>
                                      <td>Branch</td>
                                      <td>{company.branch} </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>

                            </td>

              
                            <td style={{ width: "50%", padding: "8px", verticalAlign: "top" }}>

                              <div style={{ border: "1px solid #000", padding: "8px" }}>
                                <b>Party Bank Details:</b>

                                <table style={{ width: "100%", marginTop: "5px" }} className='table table-bordered table-striped table-hover text-center align-middle'>
                                  <tbody>
                                    <tr>
                                      <td>Bank Name</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <td>Account No</td>
                                      <td> - </td>
                                    </tr>
                                    <tr>
                                      <td>IFSC Code</td>
                                      <td>- </td>
                                    </tr>
                                    <tr>
                                      <td>Branch</td>
                                      <td>- </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>

                            </td>

                          </tr>
                        </tbody>
                      </table>


                     

                      <table style={{ width: "100%", borderCollapse: "collapse" }}>
  <tbody>
    <tr> 
      <td
        style={{
          width: "100%",  
          padding: "8px",
          verticalAlign: "top",
          textAlign: "right", 
        }}
      >
        <div
          style={{
            border: "1px solid #000",
            height: "160px",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
            padding: "10px",
          }}
        >
          <b>Authorised Signatory</b>
        </div>
      </td>
    </tr>
  </tbody>
</table>



                      <table className="table table-start">
                        <tbody>
                          <tr>
                            <td
                              style={{
                                width: "34%",
                                padding: "8px",
                                verticalAlign: "top", 
                                textAlign: "left",    
                              }}
                            >
                              <div
                                style={{
                                  border: "1px solid #000",
                                  height: "160px",
                                  paddingBottom: "10px",
                                  textAlign: "left", 
                                }}
                              >
                                <strong>T & C :</strong>

                                {selectedQuotation.remark
                                  ?.split(/(?=\d+\.)/)
                                  .map((item, index) => (
                                    <div key={index} style={{ textAlign: "left" }}>
                                      {item.trim()}
                                    </div>
                                  ))}
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>


                      <div style={{ textAlign: "center", marginTop: "5px", fontSize: "12px" }}>
                        SUBJECT TO MUMBAI JURISDICTION  We are registered under MSME Act2006, Our MSME no is 'UDYAM-MH-18-0006676
                      </div>

                    </div>


                    <div
                      className="no-print"
                      style={{ marginTop: "15px", textAlign: "right" }}
                    >
                      <button
                        onClick={handlePrint}
                        style={{
                          marginRight: "10px",
                          padding: "8px 15px",
                          background: "#007bff",
                          color: "#fff",
                          border: "none",
                          borderRadius: "4px",
                        }}
                      >
                        Print
                      </button>

                      <button
                        onClick={() => setShowDownloadModal(false)}
                        style={{
                          padding: "8px 15px",
                          background: "red",
                          color: "#fff",
                          border: "none",
                          borderRadius: "4px",
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>

                      </div>

           
                  <style>
                    {`
          @media print {
            .no-print {
              display: none !important;
            }
          }
        `}
                  </style>
                </div>
              );
            })()} */}
                        </table>
                      </div>
                 {hasMore && (
                            <div className="text-center mt-3">
                                <button
                                    className="btn btn-primary"
                                    onClick={handleLoadMore}
                                >
                                    Load More
                                </button>
                            </div>
                        )}


 {showDownloadModal && selectedQuotation && (() => {
                                                    const parsedItems = selectedQuotation.items
                                                        ? JSON.parse(selectedQuotation.items)
                                                        : [];
                            
                                                    const parsedAdditionalDetails = selectedQuotation.additional_charges
                                                        ? JSON.parse(selectedQuotation.additional_charges)
                                                        : [];
                            
                            
                                                    const headerImageUrl = `https://api.skyguard.group/uploads/${branchDetail.header_img}`;
                            
                                                    return (
                                                        <>
                                                            <div
                                                                className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                                                                style={{
                                                                    backgroundColor: "rgba(0,0,0,0.5)",
                                                                    zIndex: 9999,
                                                                }}
                                                            >
                            
                                                                <div
                                                                    style={{
                                                                        background: "transparent",
                                                                        width: "95%",
                                                                        maxWidth: "1000px",
                                                                        borderRadius: "0",
                                                                        padding: "0",
                                                                        maxHeight: "95vh",
                                                                        overflowY: "auto",
                                                                        position: "relative",
                                                                        boxShadow: "none",
                                                                    }}
                                                                >
                            
                                                                    <button
                                                                        onClick={() => setShowDownloadModal(false)}
                                                                        style={{
                                                                            position: "absolute",
                                                                            top: "10px",
                                                                            right: "10px",
                                                                            border: "none",
                                                                            background: "transparent",
                                                                            fontSize: "20px",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        ✖
                                                                    </button>
                            
                            
                                                                    <div
                                                                        id="invoice-print-area"
                                                                        style={{
                                                                            position: "relative",
                                                                            background: "#fff",
                                                                            border: "2px solid #000",
                                                                            fontFamily: "Arial",
                                                                            fontSize: "13px",
                                                                        }}
                                                                    >
                            
                                                                        {/* Watermark */}
                                                                        <img
                                                                            src={headerImageUrl}
                                                                            alt=""
                                                                            style={{
                                                                                position: "absolute",
                                                                                top: "45%",
                                                                                left: "50%",
                                                                                transform: "translate(-50%,-50%)",
                                                                                width: "350px",
                                                                                opacity: 0.09,
                                                                                zIndex: 0,
                                                                            }}
                                                                        />
                            
                                                                        <div style={{ position: "relative", zIndex: 2 }}>
                            
                                                                            {/* ================= HEADER ================= */}
                            
                                                                            <div
                                                                                style={{
                                                                                    display: "flex",
                                                                                    borderBottom: "2px solid #000",
                                                                                    minHeight: "70px",
                                                                                }}
                                                                            >
                            
                                                                                {/* Title */}
                            
                                                                                <div
                                                                                    style={{
                                                                                        flex: 1,
                                                                                   
                                                                                        color: "#fff",
                                                                                        background: "#2badea",
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        justifyContent: "center",
                                                                                        fontSize: "28px",
                                                                                        fontWeight: "bold",
                                                                                        letterSpacing: 1,
                                                                                    }}
                                                                                >
                                                                                    PURCHASE RETURN
                                                                                </div>
                            
                                                                                {/* Logo */}
                            
                                                                                {/* <div
                                                                                    style={{
                                                                                        width: "120px",
                                                                                        borderLeft: "2px solid #000",
                                                                                        display: "flex",
                                                                                        justifyContent: "center",
                                                                                        alignItems: "center",
                                                                                    }}
                                                                                >
                                                                                    {branchDetail?.header_img ? (
                                                                                        <img
                                                                                            src={headerImageUrl}
                                                                                            alt=""
                                                                                            style={{
                                                                                                width: "320px",
                                                                                                height: "60px",
                                                                                                objectFit: "contain",
                                                                                            }}
                                                                                        />
                                                                                    ) : (
                                                                                        <h3>LOGO</h3>
                                                                                    )}
                                                                                </div> */}
                            
                                                                            </div>
                            
                                                                            {/* ================= COMPANY + INVOICE ================= */}
                            <div
                              style={{
                                display: "flex",
                                border: "1px solid #423d3d",
                                width: "100%",
                              }}
                            >
                              {/* Left Side - Logo */}
                              <div
                                style={{
                                  width: "20%",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  borderRight: "1px solid #ebcccc",
                                  padding: "10px",
                                  minHeight: "220px",
                                }}
                              >
                                {branchDetail?.header_img ? (
                                  <img
                                    src={headerImageUrl}
                                    alt="Company Logo"
                                    style={{
                                    width: "300px",    
                                    height: "200px",     
                                    maxWidth: "100%",
                                    objectFit: "contain",
                                  }}
                                  />
                                ) : (
                                  <h3>LOGO</h3>
                                )}
                              </div>
                            
                              {/* Right Side - Company Details */}
                              <div
                                style={{
                                  width: "80%",
                                  padding: "10px 15px",
                                }}
                              >
                                <h6
                                  style={{
                                    marginBottom: 10,
                                    fontWeight: "bold",
                                    color: "var(--invoice-header)",
                                  }}
                                >
                                  COMPANY DETAILS
                                </h6>
                            
                                <div><b>{company.name}</b></div>
                                <div>{company.address}</div>
                                <div>{company.city}, {company.state}</div>
                                <div>PIN : {company.pincode}</div>
                                <div>GSTIN : {company.gst}</div>
                                <div>PHONE : {company.phone}</div>
                                <div>EMAIL : {company.email}</div>
                                <div>PAN : {company.pan}</div>
                              </div>
                            </div>
                            
                                                                            {/* BUYER DETAILS START HERE */}
                            
                            
                                                                            {/* ================= BUYER + TERMS ================= */}
                            
                                                                            <div
                                                                                style={{
                                                                                    width: "100%",
                                                                                    padding: "2px",
                                                                                marginBottom:'8px',
                                                                                }}
                                                                            >
                                                                                
                                                                                      <div
                                                                                    style={{
                                                                                        width: "48%",
                                                                                    }}
                                                                                >
                                                                                    
                            
                                                                                </div>
                            
                            <div
                              style={{
                                display: "flex",
                                padding: "12px",
                                fontSize: "14px",
                              }}
                            >
                               
                            
                              
                              {/* Left Side */}
                              <div
                                style={{
                                  width: "50%",
                                  paddingRight: "20px",
                                  borderRight: "1px solid #ddd",
                                }}
                              >
                              <div
                                style={{
                                  fontSize: "15px",
                                  fontWeight: "bold",
                                  color: "var(--invoice-header)",
                                  marginBottom: "15px",
                                  borderBottom: "1px solid #ddd",
                                  paddingBottom: "6px",
                                }}
                              >
                                Customer Details
                              </div>
                                
                                <div style={{ display: "flex", marginBottom: "10px" }}>
                                  <div style={{ width: "40%", fontWeight: "600" }}>Name</div>
                                  <div style={{ width: "60%" }}>{selectedQuotation.party_name}</div>
                                </div>
                            
                                <div style={{ display: "flex", marginBottom: "10px" }}>
                                  <div style={{ width: "40%", fontWeight: "600" }}>Mobile</div>
                                  <div style={{ width: "60%" }}>{selectedQuotation.party_phone}</div>
                                </div>
                            
                                <div style={{ display: "flex", marginBottom: "10px" }}>
                                  <div style={{ width: "40%", fontWeight: "600" }}>Email</div>
                                  <div style={{ width: "60%" }}>{selectedQuotation.party_email}</div>
                                </div>
                            
                                <div style={{ display: "flex", marginBottom: "10px" }}>
                                  <div style={{ width: "40%", fontWeight: "600" }}>Billing Address</div>
                                  <div style={{ width: "60%" }}>{selectedQuotation.party_address}</div>
                                </div>
                            
                                <div style={{ display: "flex" }}>
                                  <div style={{ width: "40%", fontWeight: "600" }}>Shipping Address</div>
                                  <div style={{ width: "60%" }}>{selectedQuotation.delivery}</div>
                                </div>
                              </div>
                            
                              {/* Right Side */}
                              <div
                                style={{
                                  width: "50%",
                                  paddingLeft: "20px",
                                }}
                              >
                              <div
                                style={{
                                  fontSize: "15px",
                                  fontWeight: "bold",
                                  color: "var(--invoice-header)",
                                  marginBottom: "15px",
                                  borderBottom: "1px solid #ddd",
                                  paddingBottom: "6px",
                                }}
                              >
                                Quotation Details
                              </div>
                                
                                <div style={{ display: "flex", marginBottom: "10px" }}>
                                  <div style={{ width: "40%", fontWeight: "600" }}>Quotation No.</div>
                                  <div style={{ width: "60%" }}>{selectedQuotation.inv_no}</div>
                                </div>
                            
                                <div style={{ display: "flex", marginBottom: "10px" }}>
                                  <div style={{ width: "40%", fontWeight: "600" }}>Date</div>
                                  <div style={{ width: "60%" }}>{formatDateTime(selectedQuotation.date)}</div>
                                </div>
                            
                                <div style={{ display: "flex", marginBottom: "10px" }}>
                                  <div style={{ width: "40%", fontWeight: "600" }}>GST No.</div>
                                  <div style={{ width: "60%" }}>{selectedQuotation.party_gst}</div>
                                </div>
                            
                                <div style={{ display: "flex", marginBottom: "10px" }}>
                                  <div style={{ width: "40%", fontWeight: "600" }}>PAN No.</div>
                                  <div style={{ width: "60%" }}>{selectedQuotation.party_pan}</div>
                                </div>
                            
                                <div style={{ display: "flex", marginBottom: "10px" }}>
                                  <div style={{ width: "40%", fontWeight: "600" }}>MSME No.</div>
                                  <div style={{ width: "60%" }}>{selectedQuotation.party_msme}</div>
                                </div>
                            
                                <div style={{ display: "flex", marginBottom: "10px" }}>
                                  <div style={{ width: "40%", fontWeight: "600" }}>State</div>
                                  <div style={{ width: "60%" }}>{selectedQuotation.party_state}</div>
                                </div>
                            
                                <div style={{ display: "flex" }}>
                                  <div style={{ width: "40%", fontWeight: "600" }}>City</div>
                                  <div style={{ width: "60%" }}>{selectedQuotation.party_city}</div>
                                </div>
                              </div>
                            </div>
                            
                                                                         
                                                                                {/* <div style={{ display: "flex", marginBottom: "6px" }}>
                                                                                    <div style={{ flex: 1 }}>
                                                                                        <b>Party Name</b><br />
                                                                                        {selectedQuotation.party_name}
                                                                                    </div>
                            
                                                                                    <div style={{ flex: 1 }}>
                                                                                        <b>Phone</b><br />
                                                                                        {selectedQuotation.party_phone}
                                                                                    </div>
                            
                                                                                    <div style={{ flex: 1 }}>
                                                                                        <b>Email</b><br />
                                                                                        {selectedQuotation.party_email}
                                                                                    </div>
                                                                                </div>
                            
                                                                            
                                                                                <div style={{ display: "flex", marginBottom: "12px" }}>
                                                                                    <div style={{ flex: 1 }}>
                                                                                        <b>State</b><br />
                                                                                        {selectedQuotation.party_state}
                                                                                    </div>
                            
                                                                                    <div style={{ flex: 1 }}>
                                                                                        <b>City</b><br />
                                                                                        {selectedQuotation.party_city}
                                                                                    </div>
                            
                                                                                    <div style={{ flex: 1 }}>
                                                                                        <b>Pincode</b><br />
                                                                                        {selectedQuotation.party_pincode}
                                                                                    </div>
                                                                                </div>
                            
                                                                          
                                                                                <div style={{ display: "flex", marginBottom: "12px" }}>
                                                                                    <div style={{ flex: 1 }}>
                                                                                        <b>Region</b><br />
                                                                                        {selectedQuotation.party_region}
                                                                                    </div>
                            
                                                                                    <div style={{ flex: 1 }}>
                                                                                        <b>CIN No</b><br />
                                                                                        {selectedQuotation.party_cin}
                                                                                    </div>
                            
                                                                                    <div style={{ flex: 1 }}>
                                                                                        <b>MSME</b><br />
                                                                                        {selectedQuotation.party_msme}
                                                                                    </div>
                                                                                </div>
                            
                                                                         
                                                                                <div style={{ display: "flex" }}>
                                                                                    <div style={{ flex: 3 }}>
                                                                                        <b>Address</b><br />
                                                                                        {selectedQuotation.party_address}
                                                                                    </div>
                                                                                </div>
                            
                                                                                <div style={{ display: "flex" }}>
                                                                                    <div style={{ flex: 3 }}>
                                                                                        <b>Shiping Address</b><br />
                                                                                        {selectedQuotation.shipping_address}
                                                                                    </div>
                                                                                </div>
                            
                                                                                <div style={{ display: "flex" }}>
                                                                                    <div style={{ flex: 3 }}>
                                                                                        <b>GST</b><br />
                                                                                        {selectedQuotation.party_gst}
                                                                                    </div>
                                                                                </div> */}
                                                                            </div>
                            
                                                                            {/* ================= ITEMS TABLE START ================= */}
                            
                            
                                                                            <table
                                                                                style={{
                                                                                    width: "100%",
                                                                                    borderCollapse: "collapse",
                                                                                    fontSize: "10px",
                                                                                }}
                                                                            >
                            
                                                                                <thead>
                            
                                                                                    <tr
                                                                                        style={{
                                                                                            // background: "#d88aa8",
                                                                                            background: 'var(--invoice-header)',
                                                                                            color: "#000",
                                                                                        }}
                                                                                    >
                            
                                                                                        <th style={thStyle}>SL</th>
                            
                                                                                        <th style={thStyle}>ITEM / DESCRIPTION</th>
                            
                                                                                        <th style={thStyle}>HSN</th>
                            
                                                                                        <th style={thStyle}>QTY</th>
                                                                                        <th style={thStyle}>RATE</th>
                                                                                        <th style={thStyle}>GST</th>
                            
                                                                                        <th style={thStyle}>AMOUNT</th>
                            
                                                                                    </tr>
                            
                                                                                </thead>
                            
                                                                                <tbody>
                            
                                                                                    {parsedItems.map((item, index) => (
                            
                                                                                        <tr key={index}>
                            
                                                                                            <td style={tdCenter}>
                                                                                                {index + 1}
                                                                                            </td>
                            
                                                                                            <td style={tdLeft}>
                                                                                                {item.name}
                                                                                            </td>
                            
                                                                                            <td style={tdCenter}>
                                                                                                {item.hsn || "-"}
                                                                                            </td>
                            
                                                                                            <td style={tdCenter}>
                                                                                                {item.qty}
                                                                                            </td>
                            
                            
                                                                                            <td style={tdRight}>
                                                                                                ₹ {Number(item.rate).toFixed(2)}
                                                                                            </td>
                            
                                                                                            <td style={tdRight}>
                                                                                                {Number(item.tax).toFixed(2)}
                                                                                            </td>
                            
                                                                                            <td style={tdRight}>
                                                                                                ₹ {Number(item.totalAmount).toFixed(2)}
                                                                                            </td>
                            
                                                                                        </tr>
                            
                                                                                    ))}
                            
                            
                            
                                                                                    {Array.from({
                                                                                        length: Math.max(0, 3 - parsedItems.length),
                                                                                    })
                            
                                                                                    }
                            
                                                                                    {/* Additional Charges */}
                            
                                                                                    {parsedAdditionalDetails.length > 0 && (
                            
                                                                                        parsedAdditionalDetails.map((charge, index) => (
                            
                                                                                            <tr key={index}>
                            
                                                                                                <td
                                                                                                    colSpan="6"
                                                                                                    style={{
                                                                                                        border: "1px solid #000",
                                                                                                        textAlign: "right",
                                                                                                        padding: "6px",
                                                                                                        fontWeight: "bold",
                                                                                                    }}
                                                                                                >
                                                                                                    {charge.type}
                                                                                                </td>
                            
                                                                                                <td style={tdRight}>
                                                                                                    ₹ {Number(charge.value2 || 0).toFixed(2)}
                                                                                                </td>
                            
                                                                                            </tr>
                            
                                                                                        ))
                            
                                                                                    )}
                            
                                                                                </tbody>
                            
                                                                            </table>
                            
                            
                                                                            {/* ===================== SUMMARY ===================== */}
                            
                                                                            <div
                                                                                style={{
                                                                                    display: "flex",
                                                                                    border: "2px solid #000",
                                                                                    borderTop: "none",
                                                                                    minHeight: "170px",
                                                                                    marginTop:"8px",
                                                                                }}
                                                                            >
                            
                                                                                {/* LEFT */}
                            
                                                                                <div
                                                                                    style={{
                                                                                        width: "60%",
                                                                                        borderRight: "2px solid #000",
                                                                                        padding: "12px",
                                                                                    }}
                                                                                >
                            
                                                                                    <div
                                                                                        style={{
                                                                                            fontWeight: "bold",
                                                                                            // color: "#9d1f4f",
                                                                                            color: 'var(--invoice-header)',
                                                                                            fontSize: "16px",
                                                                                            marginBottom: "10px",
                                                                                        }}
                                                                                    >
                                                                                        AMOUNT IN WORDS
                                                                                    </div>
                            
                                                                                    <div
                                                                                        style={{
                                                                                            minHeight: "45px",
                                                                                            border: "1px solid #000",
                                                                                            padding: "8px",
                                                                                            marginBottom: "15px",
                                                                                        }}
                                                                                    >
                                                                                        {
                                                                                            "Rupees " +
                                                                                            toWords(Math.round(Number(selectedQuotation.grand_total || 0)))
                                                                                                .replace(/\b\w/g, (char) => char.toUpperCase()) +
                                                                                            " Only"
                                                                                        }
                                                                                    </div>
                            
                                                                                    <div
                                                                                        style={{
                                                                                            fontWeight: "bold",
                                                                                            // color: "#9d1f4f",
                                                                                            color: 'var(--invoice-header)',
                                                                                            fontSize: "16px",
                                                                                            marginBottom: "10px",
                                                                                        }}
                                                                                    >
                                                                                        Term & Condition
                                                                                    </div>
                            
                                                                                    <div
                                                                                        style={{
                                                                                            minHeight: "55px",
                                                                                            border: "1px solid #000",
                                                                                            padding: "8px",
                                                                                        }}
                                                                                    >
                                                                                        {selectedQuotation.remark
                                                                                            ? selectedQuotation.remark
                                                                                                .split(/(?=\d+\.)/)
                                                                                                .map((item, index) => (
                                                                                                    <div key={index}>
                                                                                                        {item.trim()}
                                                                                                    </div>
                                                                                                ))
                                                                                            : (
                                                                                                <>
                                                                                                    <div>1. Goods once sold will not be taken back.</div>
                            
                                                                                                    <div>2. Subject to Mumbai Jurisdiction.</div>
                            
                                                                                                    <div>3. Delivery as per commitment.</div>
                            
                                                                                                    <div>4. Payment as agreed.</div>
                            
                                                                                                    <div>5. Thank you for your business.</div>
                                                                                                </>
                                                                                            )}
                                                                                    </div>
                            
                                                                                </div>
                            
                                                                                {/* RIGHT */}
                            
                                                                                <div
                                                                                    style={{
                                                                                        width: "40%",
                                                                                    }}
                                                                                >
                            
                                                                                    <table
                                                                                        style={{
                                                                                            width: "100%",
                                                                                            borderCollapse: "collapse",
                                                                                            height: "100%",
                                                                                        }}
                                                                                    >
                            
                                                                                        <tbody>
                            
                                                                                            <tr>
                            
                                                                                                <td style={summaryTitle}>
                                                                                                    Sub Total
                                                                                                </td>
                            
                                                                                                <td style={summaryValue}>
                                                                                                    ₹ {Number(selectedQuotation.sub_total || selectedQuotation.grand_total).toFixed(2)}
                                                                                                </td>
                            
                                                                                            </tr>
                            
                            
                            
                                                                                            {parsedAdditionalDetails.map((charge, index) => {
                            
                                                                                                const gstPercent = Number(charge.gst || 0);
                                                                                                const chargeAmount = Number(charge.charge_amount || charge.value2 || 0);
                                                                                                const gstAmount = Number(charge.gst_amount || 0);
                                                                                                const finalAmount = chargeAmount + gstAmount;
                            
                                                                                                // Check if this is a transport charge
                                                                                                const isTransport =
                                                                                                    charge.type?.toLowerCase().includes("transport") ||
                                                                                                    charge.type?.toLowerCase().includes("transportation")
                            
                            
                                                                                                return (
                                                                                                    <tr key={index}>
                                                                                                        <td style={summaryTitle}>
                                                                                                            {charge.type}
                            
                                                                                                            {isTransport && gstPercent > 0 && (
                                                                                                                <>
                                                                                                                    <span style={{ fontWeight: "normal" }}>
                                                                                                                        {" "} ( GST {gstPercent}%)
                                                                                                                    </span>
                                                                                                                    <span className='text-primary'>
                                                                                                                        SAC 9968
                                                                                                                    </span>
                                                                                                                </>
                                                                                                            )}
                                                                                                        </td>
                            
                                                                                                        <td style={summaryValue}>
                                                                                                            ₹ {finalAmount.toFixed(2)}
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                );
                            
                                                                                            })}
                                                                                            <tr>
                            
                                                                                                <td style={summaryTitle}>
                                                                                                    Discount
                                                                                                </td>
                            
                                                                                                <td style={summaryValue}>
                                                                                                    ₹ {Number(selectedQuotation.bill_discount_value || 0).toFixed(2)}
                                                                                                </td>
                            
                                                                                            </tr>
                            
                                                                                            <tr>
                            
                                                                                                <td style={summaryTitle}>
                                                                                                    CGST
                                                                                                </td>
                            
                                                                                                <td style={summaryValue}>
                                                                                                    ₹ {Number(selectedQuotation.cgst || 0).toFixed(2)}
                                                                                                </td>
                            
                                                                                            </tr>
                            
                                                                                            <tr>
                            
                                                                                                <td style={summaryTitle}>
                                                                                                    SGST
                                                                                                </td>
                            
                                                                                                <td style={summaryValue}>
                                                                                                    ₹ {Number(selectedQuotation.sgst || 0).toFixed(2)}
                                                                                                </td>
                            
                                                                                            </tr>
                            
                                                                                            <tr>
                            
                                                                                                <td style={summaryTitle}>
                                                                                                    IGST
                                                                                                </td>
                            
                                                                                                <td style={summaryValue}>
                                                                                                    ₹ {Number(selectedQuotation.igst || 0).toFixed(2)}
                                                                                                </td>
                            
                                                                                            </tr>
                            
                                                                                            <tr>
                            
                                                                                                <td style={summaryTitle}>
                                                                                                    Round Off
                                                                                                </td>
                            
                                                                                                <td style={summaryValue}>
                                                                                                    ₹ {Number(selectedQuotation.round_off || 0).toFixed(2)}
                                                                                                </td>
                            
                                                                                            </tr>
                            
                                                                                            <tr
                                                                                                style={{
                                                                                                    // background: "#d88aa8",
                                                                                                    background: 'var(--invoice-header)',
                                                                                                    fontWeight: "bold",
                                                                                                    fontSize: "16px",
                                                                                                }}
                                                                                            >
                            
                                                                                                <td
                                                                                                    style={{
                                                                                                        border: "1px solid #000",
                                                                                                        padding: "10px",
                                                                                                        color:'white'
                                                                                                    }}
                                                                                                >
                                                                                                    GRAND TOTAL
                                                                                                </td>
                            
                                                                                                <td
                                                                                                    style={{
                                                                                                        border: "1px solid #000",
                                                                                                        padding: "10px",
                                                                                                        textAlign: "right",
                                                                                                         color:'white'
                                                                                                    }}
                                                                                                >
                                                                                                    ₹ {Number(selectedQuotation.grand_total).toFixed(2)}
                                                                                                </td>
                            
                                                                                            </tr>
                            
                                                                                        </tbody>
                            
                                                                                    </table>
                            
                                                                                </div>
                            
                                                                            </div>
                            
                            
                                                                            {/* ===================== BANK DETAILS ===================== */}
                            
                                                                            <div
                                                                                style={{
                                                                                    display: "flex",
                                                                                    border: "2px solid #000",
                                                                                    borderTop: "none",
                                                                                }}
                                                                            >
                            
                                                                                {/* Company Bank */}
                            
                                                                                {/* <div
                                                                                    style={{
                                                                                        width: "50%",
                                                                                        borderRight: "2px solid #000",
                                                                                        padding: "12px",
                                                                                    }}
                                                                                >
                            
                                                                                    <div
                                                                                        style={{
                                                                                          
                                                                                            background: 'var(--invoice-header)',
                                                                                            padding: "8px",
                                                                                            fontWeight: "bold",
                                                                                            marginBottom: "10px",
                                                                                        }}
                                                                                    >
                                                                                        COMPANY BANK DETAILS
                                                                                    </div>
                            
                                                                                    <table
                                                                                        style={{
                                                                                            width: "100%",
                                                                                            borderCollapse: "collapse",
                                                                                        }}
                                                                                    >
                            
                                                                                        <tbody>
                            
                                                                                            <tr>
                                                                                                <td style={bankTitle}>Bank Name</td>
                                                                                                <td style={bankValue}>{company.bank_name}</td>
                                                                                            </tr>
                            
                                                                                            <tr>
                                                                                                <td style={bankTitle}>Account No.</td>
                                                                                                <td style={bankValue}>{company.acc_no}</td>
                                                                                            </tr>
                            
                                                                                            <tr>
                                                                                                <td style={bankTitle}>IFSC</td>
                                                                                                <td style={bankValue}>{company.ifsc}</td>
                                                                                            </tr>
                            
                                                                                            <tr>
                                                                                                <td style={bankTitle}>Branch</td>
                                                                                                <td style={bankValue}>{company.branch}</td>
                                                                                            </tr>
                            
                                                                                        </tbody>
                            
                                                                                    </table>
                            
                                                                                </div> */}
                            
                                                                                {/* Customer Bank */}
                            
                                                                                <div
                                                                                    style={{
                                                                                        width: "50%",
                                                                                        padding: "12px",
                                                                                    }}
                                                                                >
                            
                                                                                    <div
                                                                                        style={{
                                                                                            // background: "#d88aa8",
                                                                                            background: 'var(--invoice-header)',
                                                                                            padding: "8px",
                                                                                            fontWeight: "bold",
                                                                                         
                                                                                            color:"white"
                                                                                        }}
                                                                                    >
                                                                                        CUSTOMER BANK DETAILS
                                                                                    </div>
                            
                                                                                    <table
                                                                                        style={{
                                                                                            width: "100%",
                                                                                            borderCollapse: "collapse",
                                                                                        }}
                                                                                    >
                            
                                                                                        <tbody>
                            
                                                                                            <tr>
                                                                                                <td style={bankTitle}>Bank Name</td>
                                                                                                <td style={bankValue}>-</td>
                                                                                            </tr>
                            
                                                                                            <tr>
                                                                                                <td style={bankTitle}>Account No.</td>
                                                                                                <td style={bankValue}>-</td>
                                                                                            </tr>
                            
                                                                                            <tr>
                                                                                                <td style={bankTitle}>IFSC</td>
                                                                                                <td style={bankValue}>-</td>
                                                                                            </tr>
                            
                                                                                            <tr>
                                                                                                <td style={bankTitle}>Branch</td>
                                                                                                <td style={bankValue}>-</td>
                                                                                            </tr>
                            
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                style={{
                                                                                    border: "2px solid #000",
                                                                                    borderTop: "none",
                                                                                    minHeight: "150px",
                                                                                    display: "flex",
                                                                                    justifyContent: "flex-end",
                                                                                }}
                                                                            >
                                                                                <div
                                                                                    style={{
                                                                                        width: "35%",
                                                                                        padding: "15px",
                                                                                        display: "flex",
                                                                                        flexDirection: "column",
                                                                                        justifyContent: "space-between",
                                                                                        alignItems: "center",
                                                                                    }}
                                                                                >
                                                                                    <div
                                                                                        style={{
                                                                                            fontWeight: "bold",
                                                                                            fontSize: "15px",
                                                                                        }}
                                                                                    >
                                                                                        For {company.name}
                                                                                    </div>
                            
                                                                                    {/* Signature Space */}
                                                                                    <div
                                                                                        style={{
                                                                                            height: "70px",
                                                                                            width: "100%",
                                                                                        }}
                                                                                    ></div>
                            
                                                                                    <div
                                                                                        style={{
                                                                                            borderTop: "1px solid #000",
                                                                                            width: "100%",
                                                                                            textAlign: "center",
                                                                                            paddingTop: "8px",
                                                                                            fontWeight: "bold",
                                                                                        }}
                                                                                    >
                                                                                        Authorized Signatory
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                            
                                                                            {/* ===================== FOOTER ===================== */}
                            
                                                                            <div
                                                                                style={{
                                                                                    border: "2px solid #000",
                                                                                    borderTop: "none",
                                                                                    textAlign: "center",
                                                                                    padding: "10px",
                                                                                    fontSize: "12px",
                                                                                    background: "#f8f8f8",
                                                                                }}
                                                                            >
                            
                                                                                SUBJECT TO MUMBAI JURISDICTION
                            
                                                                                <br />
                            
                                                                                Thank you for your business.
                            
                                                                            </div>
                            
                                                                            {/* ===================== BUTTONS ===================== */}
                            
                                                                            <div
                                                                                className="no-print mb-2"
                                                                                style={{
                                                                                    display: "flex",
                                                                                    justifyContent: "end",
                                                                                    gap: "10px",
                                                                                    marginTop: "20px",
                                                                                }}
                                                                            >
                            
                                                                                <button
                                                                                    className="btn btn-success"
                                                                                    onClick={handlePrint}
                                                                                >
                                                                                    Print Invoice
                                                                                </button>
                            
                                                                                <button
                                                                                    className="btn btn-danger"
                                                                                    onClick={() => setShowDownloadModal(false)}
                                                                                >
                                                                                    Close
                                                                                </button>
                            
                                                                            </div>
                            
                            
                            
                                                                        </div>
                            
                            
                                                                        <style>
                                                                            {`
                                      @media print {
                                        .no-print {
                                          display: none !important;
                                        }
                                      }
                                    `}
                                                                        </style>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    );
                                                })()}
            </div>
        </div>
    )
}

export default Return

const exportInvoiceToExcel = (selectedQuotation) => {
  const items = selectedQuotation.items
    ? JSON.parse(selectedQuotation.items)
    : [];

  const additionalDetails = selectedQuotation.additional_charges
    ? JSON.parse(selectedQuotation.additional_charges)
    : [];

  // ================= HEADER =================
  const headerData = [
    ["STAR SIGNATURE SERVICES"],
    ["A-8 JAI ISH KRUPA CHS LTD. ANAND NAGAR OPP AL-NOOR MASZID VASAI W 401202 THANE MUMBAI MAHARASHTRA"],
    ["Phone: 9209206677 / 9209203355 / 9324004632"],
    ["Email: starsignatureservices@gmail.com"],
    ["GSTIN: 27ADYPY53133M2ZH"],
    [],
    ["Customer Detail"],
    [`Name: ${selectedQuotation.party_name}`],
    [`Contact: ${selectedQuotation.party_phone}`],
    [`Bill By: ${selectedQuotation.added_first_name || ""} ${selectedQuotation.added_middle_name || ""} ${selectedQuotation.added_last_name || ""}`],
    [`Date: ${selectedQuotation.date}`],
    []
  ];

  // ================= ADDRESS & INVOICE =================
  const addressData = [
    ["Address & Invoice Details"],
    [`Billing Address: ${selectedQuotation.bill || "-"}`],
    [`Delivery Address: ${selectedQuotation.delivery || "-"}`],
    [`Invoice No.: ${selectedQuotation.invoice || "-"}`],
    [`Invoice Date: ${selectedQuotation.invoice_date || "-"}`],
    []
  ];

  // ================= ITEMS TABLE =================
  const itemHeader = [["Item Name", "Qty", "Rate", "GST", "Amount"]];
  const itemRows = items.length
    ? items.map(item => [item.name, item.qty, item.rate, item.tax, item.amount])
    : [["No Items Found", "", "", "", ""]];

  // ================= ADDITIONAL DETAILS =================
  const additionalHeader = additionalDetails.length > 0 ? [["Additional Detail", "", "", "", ""]] : [];
  const additionalRows = additionalDetails.map(ad => [ad.type, "", "", ad.value1, ad.value2]);

  // ================= TOTALS =================
  const totals = [
    [],
    ["Sub Total", "", "", "", Number(selectedQuotation.sub_total || 0).toFixed(2)],
    ["Total GST", "", "", "", Number(selectedQuotation.total_gst || 0).toFixed(2)],
    ["Grand Total", "", "", "", Number(selectedQuotation.grand_total || 0).toFixed(2)]
  ];

  // ================= REMARK =================
  const remarkSection = selectedQuotation.remark
    ? [["Remark"], [selectedQuotation.remark]]
    : [];

  // ================= FINAL DATA =================
  const finalData = [
    ...headerData,
    ...addressData,       // <-- Address + Invoice section
    ...itemHeader,
    ...itemRows,
    ...additionalHeader,
    ...additionalRows,
    ...totals,
    ...remarkSection
  ];

  const worksheet = XLSX.utils.aoa_to_sheet(finalData);

  // Set column widths
  worksheet["!cols"] = [
    { wch: 30 },
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
    { wch: 15 }
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Invoice");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, `Invoice_${selectedQuotation.party_name || "Customer"}.xlsx`);
};
